import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import confetti from "canvas-confetti";
import heroImage from "../../assets/ConsultantMidLevel.jpg";
import edtechPlatformVideo from "../../assets/Edtech Platform.mp4";
import seniorBrochurePdf from "../../assets/Appsec-VAPT-Senior-Penetration-Tester.pdf";
import tool1 from "../../assets/ToolsForAssociate/1.jpg";
import tool2 from "../../assets/ToolsForAssociate/2.png";
import tool3 from "../../assets/ToolsForAssociate/3.jpg";
import tool4 from "../../assets/ToolsForAssociate/4.png";
import wiresharkTool from "../../assets/ToolsForAssociate/wireshark.svg";
import tool6 from "../../assets/ToolsForAssociate/6.png";
import tool7 from "../../assets/ToolsForAssociate/7.jpg";
import niktoTool from "../../assets/ToolsForConsultant/5.png";
import tool9 from "../../assets/ToolsForAssociate/9.jpg";
import tool10 from "../../assets/ToolsForAssociate/10.png";
import mobsf from "../../assets/ToolsForConsultant/7.png";
import apktool from "../../assets/ToolsForConsultant/8.png";
import androidDrozer from "../../assets/ToolsForConsultant/9.jpg";
import frida from "../../assets/ToolsForConsultant/10.png";
import objection from "../../assets/ToolsForConsultant/11.png";
import postman from "../../assets/ToolsForConsultant/12.png";
import ghidra from "../../assets/ToolsForConsultant/13.png";
import procexp from "../../assets/ToolsForConsultant/14.png";
import procmon from "../../assets/ToolsForConsultant/15.jpg";
import AlumniSuccessStories from "../../components/AlumniSuccessStories/AlumniSuccessStories";



const API_URL = process.env.REACT_APP_API_URL;

const DEFAULT_FEE = {
  TotalCourseFee: 50000,
  AfterOfferCourseFee: 45000,
  DiscountPercentage: 24,
  FirstInstallmentAmount: 25000,
  SecondInstallmentAmount: 20000,
  FirstInstallmentLink: "https://rzp.io/rzp/senior-instalment",
  SecondInstallmentLink: "https://rzp.io/rzp/senior-instalment",
};

const DEFAULT_COHORTS = [
  {
    id: 1,
    BatchStartDate: "23-July-2026",
    BatchEndDate: "11-September-2026",
    Duration: "1.5 Months",
    BatchType: "MORNING",
    Timings: "07:00 AM TO 08:00 AM",
    Mode: "LIVE/ONLINE",
    Language: "ENGLISH",
    Sessions: "MON - FRI",
    LearningPlatform: "Practical Infosec LMS + Live Classes",
  },
];

const COUNTRY_CODES = [
  { code: "+91", name: "India" },
  { code: "+1", name: "United States" },
  { code: "+44", name: "United Kingdom" },
  { code: "+971", name: "United Arab Emirates" },
  { code: "+65", name: "Singapore" },
  { code: "+61", name: "Australia" },
  { code: "+1", name: "Canada" },
  { code: "+93", name: "Afghanistan" },
  { code: "+355", name: "Albania" },
  { code: "+213", name: "Algeria" },
  { code: "+880", name: "Bangladesh" },
  { code: "+55", name: "Brazil" },
  { code: "+86", name: "China" },
  { code: "+33", name: "France" },
  { code: "+49", name: "Germany" },
  { code: "+62", name: "Indonesia" },
  { code: "+353", name: "Ireland" },
  { code: "+39", name: "Italy" },
  { code: "+81", name: "Japan" },
  { code: "+60", name: "Malaysia" },
  { code: "+977", name: "Nepal" },
  { code: "+31", name: "Netherlands" },
  { code: "+64", name: "New Zealand" },
  { code: "+92", name: "Pakistan" },
  { code: "+974", name: "Qatar" },
  { code: "+966", name: "Saudi Arabia" },
  { code: "+94", name: "Sri Lanka" },
  { code: "+66", name: "Thailand" },
];

const courseModules = [
  {
    title: "Network & Cybersecurity Fundamentals",
    weeks: [
      {
        week: "Week - 1 :",
        topics: [
          "IP Address, Ports & Protocols",
          "OSI, TCP/IP Layer",
          "VPN Setup & Vulnerable Web Application Setup",
          "Network PT Lab Setup",
          "CIA Triad, Cryptography, Security Acronyms",
        ],
      },
    ],
  },
  {
    title: "Network Penetration Testing",
    weeks: [
      {
        week: "Week - 2 :",
        topics: [
          "Exploring Wireshark",
          "Enumeration with Nmap",
          "Exploiting Vulnerable Services with Metasploit",
          "Network Scanning with Nessus",
          "CIA Triad, Cryptography, Security Acronyms",
        ],
      },
    ],
  },
  {
    title: "OWASP",
    weeks: [
      {
        week: "Week - 3 :",
        topics: [
          "VAPT Fundamentals",
          "OWASP Intro",
          "Burp Suite Tool Walkthrough",
        ],
      },
    ],
  },
  {
    title: "Web Application Penetration Testing",
    weeks: [
      {
        week: "Week - 4 :",
        topics: [
          "Broken Authentication",
          "Session Management Flaws",
          "Broken Access Control",
        ],
      },
      {
        week: "Week - 5 :",
        topics: [
          "Cross-Site Request Forgery (CSRF)",
          "Cross-Site Scripting (XSS)",
          "Unrestricted File Upload",
        ],
      },
      {
        week: "Week - 6 :",
        topics: [
          "File Inclusion (LFI & RFI)",
          "SQL Injection",
          "OS Command Injection",
        ],
      },
      {
        week: "Week - 7 :",
        topics: [
          "Server-Side Request Forgery (SSRF)",
          "External XML Entity (XXE)",
          "Insecure Deserialization",
        ],
      },
    ],
  },
  {
    title: "CTF & Bug Bounty",
    weeks: [
      {
        week: "Week - 8 :",
        topics: [
          "Capture The Flag",
          "Bug Bounty Hunting",
        ],
      },
    ],
  },
  {
    title: "Android Application Penetration Testing",
    weeks: [
      {
        week: "Week - 9 :",
        topics: [
          "Android Architecture",
          "Bug Bounty Hunting",
          "Reverse Engineering / Static Analysis",
        ],
      },
      {
        week: "Week - 10 :",
        topics: [
          "Client Code Quality",
          "Insecure Data Storage",
          "Component Exploitation / Runtime Analysis",
        ],
      },
      {
        week: "Week - 11 :",
        topics: [
          "SSL Pinning Bypass / Dynamic Analysis",
          "MobSF / Security Misconfiguration",
          "WebView Exploitation",
        ],
      },
    ],
  },
  {
    title: "API Penetration Testing",
    weeks: [
      {
        week: "Week - 12 :",
        topics: [
          "API Security Fundamentals",
          "API Vulnerable Lab & Tools Setup",
          "Broken Authentication",
        ],
      },
      {
        week: "Week - 13 :",
        topics: [
          "Broken Object Level Authorization (BOLA)",
          "Broken Function Level Authorization",
          "Rate Limiting Issues",
          "Excessive Data Exposure",
          "Mass Assignment",
        ],
      },
      {
        week: "Week - 14 :",
        topics: [
          "Improper Inventory Management",
          "SQL Injection",
          "Server-Side Request Forgery (SSRF)",
          "External XML Entity (XXE)",
        ],
      },
    ],
  },
  {
    title: "Thick Client Penetration Testing",
    weeks: [
      {
        week: "Week - 15 :",
        topics: [
          "Thick Client Applications Intro",
          "Setting Up Thick Client Pentesting Lab & Tools",
          "Network Traffic Analysis / Echo Mirage",
        ],
      },
      {
        week: "Week - 16 :",
        topics: [
          "CSV and SQL Injection",
          "Sensitive Data Exposure",
          "DLL Hijacking",
        ],
      },
      {
        week: "Week - 17 :",
        topics: [
          "Reverse Engineering",
          "Career Guidance",
        ],
      },
    ],
  },
];





const demoRows = [
  {
    title: "Senior Penetration Tester - Recent Demo",
    status: "Open",
  },
];

function formatCurrency(value) {
  return `₹${Number(value || 0).toLocaleString("en-IN")}`;
}

function onlyDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

function validateEmailValue(value) {
  return /^\S+@\S+\.\S+$/.test(value || "");
}

function validatePhoneValue(value) {
  const digits = onlyDigits(value);

  if (!digits) return "Please enter phone number";
  if (digits.length < 7 || digits.length > 15) {
    return "Phone number must be 7-15 digits";
  }

  return "";
}

function toIsoDate(value) {
  if (!value && value !== 0) return null;

  const text = String(value).trim();

  if (/^\d{2}-\d{2}-\d{4}$/.test(text)) {
    const [dd, mm, yyyy] = text.split("-");
    return `${yyyy}-${mm}-${dd}`;
  }

  const parsed = dayjs(text);
  return parsed.isValid() ? parsed.toISOString() : null;
}

function normalizeBatchDay(value) {
  if (!value && value !== 0) return "";

  let text = String(value).trim().toUpperCase();
  text = text.replace(/[^A-Z]/g, "");

  if (text.includes("MORN") || text === "M" || text === "AM") return "MORNING";
  if (text.includes("EVE") || text === "E" || text === "PM") return "EVENING";
  if (text === "MORNING" || text === "EVENING") return text;

  return text;
}

function getDisplayDate(value, fallback = "23-July-2026") {
  if (!value) return fallback;

  const parsed = dayjs(value);
  if (parsed.isValid()) return parsed.format("DD-MMMM-YYYY");

  return value;
}

function SeniorPenetrationTester() {
  const location = useLocation();
  const navigate = useNavigate();

  function goToDemoRegistrationPage() {
  navigate("/senior-penetration-tester-demo");
}

  const [callbackOpen, setCallbackOpen] = useState(false);
  const [installmentOpen, setInstallmentOpen] = useState(false);
  const [whatsappOpen, setWhatsappOpen] = useState(false);

  const [fee, setFee] = useState(DEFAULT_FEE);
  const [cohorts, setCohorts] = useState(DEFAULT_COHORTS);

  
const [showBackToTop, setShowBackToTop] = useState(false);

  const [selectedInstallmentBatch, setSelectedInstallmentBatch] = useState("");


  const [callbackForm, setCallbackForm] = useState({
    name: "",
    email: "",
    countryCode: "+91",
    phone: "",
    message: "",
  });

  const [brochureOpen, setBrochureOpen] = useState(false);

const [brochureForm, setBrochureForm] = useState({
  name: "",
  email: "",
  countryCode: "+91",
  phone: "",
});

const [brochureErrors, setBrochureErrors] = useState({});

  const [activeDemoTab, setActiveDemoTab] = useState("professional");
  const [batchDayFilter, setBatchDayFilter] = useState("MORNING");
  const [demoBatches, setDemoBatches] = useState([]);
  const [loadingDemoBatches, setLoadingDemoBatches] = useState(false);
  const [demoBatchesError, setDemoBatchesError] = useState("");
  const [selectedDemoBatchKey, setSelectedDemoBatchKey] = useState("");
  const [requestCallback, setRequestCallback] = useState("NO");
  const [demoFormErrors, setDemoFormErrors] = useState({});
  const [demoFormMessage, setDemoFormMessage] = useState("");
  const [openCourseModuleIndex, setOpenCourseModuleIndex] = useState(0);
const [openCourseWeekKey, setOpenCourseWeekKey] = useState("0-0");

  const [demoLeadForm, setDemoLeadForm] = useState({
    fullName: "",
    email: "",
    countryCode: "+91",
    phone: "",
    collegeName: "",
    passedOutYear: "",
    companyName: "",
    yearsOfExperience: "",
  });

  const latestCohort = cohorts?.[0] || DEFAULT_COHORTS[0];

  const technologyLogos = [
  {
    image: tool1,
    alt: "Kali Linux",
    className: "h-[60px] w-auto",
  },
  {
    image: tool2,
    alt: "BurpSuite",
    className: "h-[60px] w-auto bg-white",
  },
  {
    image: tool3,
    alt: "Nmap",
    className: "h-[112px] w-auto",
  },
  {
    image: tool4,
    alt: "Metasploit",
    className: "h-[80px] w-auto",
  },
  {
    image: wiresharkTool,
    alt: "Wireshark",
    className: "h-[100px] w-auto",
  },
  {
    image: tool6,
    alt: "OWASP ZAP",
    className: "h-[80px] w-auto",
  },
  {
    image: tool7,
    alt: "Sql map",
    className: "h-[68px] w-auto",
  },
  {
    image: niktoTool,
    alt: "Nessus",
    className: "h-[56px] w-[140px] object-contain",
  },
  {
    image: tool9,
    alt: "Enumeration",
    className: "h-[60px] w-auto",
  },
  {
    image: tool10,
    alt: "Security Tool",
    className: "h-[80px] w-auto",
  },
  {
    image: mobsf,
    alt: "MobSf",
    className: "h-[80px] w-auto",
  },
  {
    image: apktool,
    alt: "Apk Tool",
    className: "h-[80px] w-auto",
  },
  {
    image: androidDrozer,
    alt: "Drozer",
    className: "h-[80px] w-auto",
  },
  {
    image: frida,
    alt: "frida",
    className: "h-[80px] w-auto",
  },
  {
    image: objection,
    alt: "Objection",
    className: "h-[80px] w-auto",
  },
  {
    image: postman,
    alt: "Postman",
    className: "h-[80px] w-auto",
  },
  {
    image: ghidra,
    alt: "Ghidra",
    className: "h-[80px] w-auto",
  },
  {
    image: procexp,
    alt: "Process Explore",
    className: "h-[80px] w-auto",
  },
  {
    image: procmon,
    alt: "Process Monitor",
    className: "h-[80px] w-auto",
  },
];

  useEffect(() => {
    if (location.hash === "#demoRegistration") {
      setTimeout(() => {
        document.getElementById("demoRegistration")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 300);
    }
  }, [location]);

  useEffect(() => {
    async function loadPageData() {
      try {
        // console.log("API_URL:", API_URL);

        const [cohortRes, feeRes] = await Promise.allSettled([
          axios.get(`${API_URL}/senior/cohort-details-senior`),
          axios.get(`${API_URL}/coursefeesenior/course-fee-senior`),
        ]);

        // console.log("Cohort response:", cohortRes);
        // console.log("Fee response:", feeRes);

        if (
          cohortRes.status === "fulfilled" &&
          Array.isArray(cohortRes.value.data?.data) &&
          cohortRes.value.data.data.length > 0
        ) {
          setCohorts(cohortRes.value.data.data);
        }

        if (
          feeRes.status === "fulfilled" &&
          Array.isArray(feeRes.value.data?.data) &&
          feeRes.value.data.data.length > 0
        ) {
          setFee({
            ...DEFAULT_FEE,
            ...feeRes.value.data.data[0],
          });
        }
      } catch (error) {
        console.error("Page data loading failed:", error);
      }
    }

    loadPageData();
  }, []);

  const SUPPORT_WHATSAPP_NUMBER = "919080432374";
const SUPPORT_MESSAGE = "Hi, I am Looking for Cyber Security Training";

useEffect(() => {
  function handleScroll() {
    setShowBackToTop(window.scrollY > 300);
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll();

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

function toggleWhatsAppModal(event) {
  if (event) {
    event.stopPropagation();
  }

  setWhatsappOpen((prev) => !prev);
}

function handleDownloadBrochureClick() {
  setBrochureOpen(true);
}

function openWhatsAppChat() {
  const encodedMessage = encodeURIComponent(SUPPORT_MESSAGE);
  const whatsappUrl = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodedMessage}`;

  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
}

function openWhatsAppAppFallback() {
  const encodedMessage = encodeURIComponent(SUPPORT_MESSAGE);
  const deepLink = `whatsapp://send?phone=${SUPPORT_WHATSAPP_NUMBER}&text=${encodedMessage}`;
  const webLink = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodedMessage}`;

  window.location.href = deepLink;

  setTimeout(() => {
    window.open(webLink, "_blank", "noopener,noreferrer");
  }, 700);
}

function handleCourseModuleToggle(moduleIndex) {
  if (openCourseModuleIndex === moduleIndex) {
    setOpenCourseModuleIndex(null);
    setOpenCourseWeekKey(null);
    return;
  }

  setOpenCourseModuleIndex(moduleIndex);
  setOpenCourseWeekKey(`${moduleIndex}-0`);
}

function handleCourseWeekToggle(moduleIndex, weekIndex) {
  const weekKey = `${moduleIndex}-${weekIndex}`;

  if (openCourseWeekKey === weekKey) {
    setOpenCourseWeekKey(null);
    return;
  }

  setOpenCourseWeekKey(weekKey);
}

  const CRM_API_URL = `https://api.practicalinfosec.com/api`
  async function loadDemoBatches(months = 3) {
    setLoadingDemoBatches(true);
    setDemoBatchesError("");

    const GRACE_DAYS = 4;

    try {
      const response = await axios.get(
        `${CRM_API_URL.replace(/\/$/, "")}/demolinks/all-demolinks`,
        { timeout: 10000 }
      );

      const rows = Array.isArray(response.data?.data) ? response.data.data : [];

      const wantedMonthKeys = [];
      const now = dayjs();

      for (let i = 0; i < months; i += 1) {
        wantedMonthKeys.push(now.add(i, "month").format("YYYY-MM"));
      }

      const monthMap = new Map();

      for (const row of rows) {
        const groupingIso = toIsoDate(row.BatchStartDate ?? row.DemoDate);
        if (!groupingIso) continue;

        const groupingDate = dayjs(groupingIso);
        if (!groupingDate.isValid()) continue;

        const monthKey = groupingDate.format("YYYY-MM");
        if (!wantedMonthKeys.includes(monthKey)) continue;

        if (groupingDate.isSame(now, "month")) {
          const batchStartIso = toIsoDate(row.BatchStartDate);

          if (batchStartIso) {
            const batchStart = dayjs(batchStartIso);
            const graceEnd = batchStart.add(GRACE_DAYS, "day");

            if (now.isAfter(graceEnd)) continue;
          }
        }

        const demoIso = toIsoDate(row.DemoDate);
        const batchStartIso = toIsoDate(
          row.BatchStartDate ?? demoIso ?? groupingIso
        );

        const normalizedRow = {
          ...row,
          __groupIso: groupingIso,
          __groupDayjs: groupingDate,
          __batchStartIso: batchStartIso,
          __demoDateIso: demoIso,
          __batchDayNorm: normalizeBatchDay(
            row.BatchDay ?? row.batchDay ?? row.Day ?? ""
          ),
          __timeRaw: String(row.BatchTime ?? row.Time ?? ""),
        };

        if (!monthMap.has(monthKey)) {
          monthMap.set(monthKey, []);
        }

        monthMap.get(monthKey).push(normalizedRow);
      }

      const computedBatches = wantedMonthKeys
        .map((monthKey) => {
          const monthRows = monthMap.get(monthKey) || [];
          if (!monthRows.length) return null;

          monthRows.sort((a, b) =>
            a.__groupDayjs.isBefore(b.__groupDayjs) ? -1 : 1
          );

          const representative = monthRows[0];

          return {
            key: monthKey,
            label: dayjs(representative.__batchStartIso).isValid()
              ? dayjs(representative.__batchStartIso).format("MMM YYYY")
              : monthKey,
            time: representative.__timeRaw || "TBD",
            batchStartIso: representative.__batchStartIso,
            batchDay: representative.__batchDayNorm || "",
            representativeId: representative.id ?? null,
            rawRows: monthRows,
          };
        })
        .filter(Boolean);

      setDemoBatches(computedBatches);
    } catch (error) {
      console.error("Demo batch loading failed:", error);
      setDemoBatchesError(error.message || "Failed to load batches");
    } finally {
      setLoadingDemoBatches(false);
    }
  }

  useEffect(() => {
    loadDemoBatches(3);
  }, []);

  const displayedDemoBatches = useMemo(() => {
    return demoBatches
      .map((batch) => {
        if (!Array.isArray(batch.rawRows) || !batch.rawRows.length) return null;

        const matchedRow = batch.rawRows.find((row) => {
          const normalizedDay = normalizeBatchDay(
            row.__batchDayNorm ?? row.BatchDay ?? row.batchDay ?? row.Day ?? ""
          );

          return normalizedDay === batchDayFilter;
        });

        if (!matchedRow) return null;

        const batchStartIso =
          matchedRow.__batchStartIso ?? batch.batchStartIso ?? null;

        return {
          key: batch.key,
          label: batch.label,
          time: matchedRow.__timeRaw || batch.time || "TBD",
          batchStartIso,
          batchDay:
            normalizeBatchDay(
              matchedRow.__batchDayNorm ?? matchedRow.BatchDay ?? ""
            ) || batch.batchDay,
          rawRows: batch.rawRows,
          representativeId: matchedRow.id ?? batch.representativeId ?? null,
        };
      })
      .filter(Boolean);
  }, [demoBatches, batchDayFilter]);

  useEffect(() => {
    if (!displayedDemoBatches.length) {
      setSelectedDemoBatchKey("");
      return;
    }

    const selectedStillExists = displayedDemoBatches.some(
      (batch) => batch.key === selectedDemoBatchKey
    );

    if (!selectedStillExists) {
      setSelectedDemoBatchKey(displayedDemoBatches[0].key);
    }
  }, [displayedDemoBatches, selectedDemoBatchKey]);

  function scrollToDemoRegistration() {
    document.getElementById("demoRegistration")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  function trackEvent(eventName, payload = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      course_name: "senior Penetration Tester",
      ...payload,
    });
  }

  async function submitCallbackLead(payload, successMessage) {
    Swal.fire({
      title: "Please Wait...",
      html: "Submitting your request...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      await axios.post(`${CRM_API_URL}/leads/form-callback-professional`, payload, {
        timeout: 10000,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
      });

      Swal.fire({
        icon: "success",
        title: "Submitted!",
        text: successMessage,
        confirmButtonColor: "#1d4ed8",
      });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Submission failed";

      throw new Error(message);
    }
  }

  async function handleCallbackSubmit(event) {
    event.preventDefault();

    if (
      callbackForm.name.trim().length < 4 ||
      !validateEmailValue(callbackForm.email) ||
      validatePhoneValue(callbackForm.phone)
    ) {
      Swal.fire({
        icon: "warning",
        title: "Please check your details",
        text: "Full name, valid email and phone number are required.",
        confirmButtonColor: "#1d4ed8",
      });
      return;
    }

    const payload = {
      FullName: callbackForm.name.trim(),
      Email: callbackForm.email.trim(),
      PhoneNumber: `${callbackForm.countryCode} ${callbackForm.phone.trim()}`,
      LeadCategory: "PROFESSIONAL",
      LeadSource: "ORGANIC",
      EnrollmentType: "SENIOR PENETRATION TESTER",
      CollegeName: "From Get A Call Back",
      PassedOutYear: "2026",
      AvailabilityBatch: "NA",
      BatchDay: "NA",
      CallBack: "YES",
      Message: callbackForm.message.trim(),
    };

    try {
      await submitCallbackLead(
        payload,
        "🎉 Your callback request has been received. Our team will get back to you soon."
      );

      trackEvent("callback_request_submit", {
        lead_category: "PROFESSIONAL",
        lead_source: "ORGANIC",
      });

      setCallbackOpen(false);
      setCallbackForm({
        name: "",
        email: "",
        countryCode: "+91",
        phone: "",
        message: "",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: error.message || "Something went wrong. Please try again later.",
      });
    }
  }

  async function handleDemoRegistrationSubmit(event) {
    event.preventDefault();

    const errors = {};

    const fullName = demoLeadForm.fullName.trim();
    const email = demoLeadForm.email.trim();
    const phone = demoLeadForm.phone.trim();

    if (!fullName || fullName.length < 2) {
      errors.fullName = "Please enter a valid name";
    }

    if (!email || !validateEmailValue(email)) {
      errors.email = "Please enter a valid email";
    }

    const phoneError = validatePhoneValue(phone);
    if (phoneError) {
      errors.phone = phoneError;
    }

    if (activeDemoTab === "student") {
      if (!demoLeadForm.collegeName.trim()) {
        errors.collegeName = "Enter college name";
      }

      if (
        !demoLeadForm.passedOutYear.trim() ||
        !/^[0-9]{4}$/.test(demoLeadForm.passedOutYear.trim())
      ) {
        errors.passedOutYear = "Enter a valid 4-digit year";
      }
    }

    if (activeDemoTab === "professional") {
      if (!demoLeadForm.companyName.trim()) {
        errors.companyName = "Enter company name";
      }

      if (demoLeadForm.yearsOfExperience === "") {
        errors.yearsOfExperience = "Select years of experience";
      }
    }

    if (!selectedDemoBatchKey) {
      errors.batch = "Please select a batch";
    }

    setDemoFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      setDemoFormMessage("Fix the highlighted errors and try again.");
      return;
    }

    const selectedBatch =
      displayedDemoBatches.find((batch) => batch.key === selectedDemoBatchKey) ||
      null;

    const isStudent = activeDemoTab === "student";

    const payload = {
      FullName: fullName,
      Email: email,
      PhoneNumber: `${demoLeadForm.countryCode || "+91"} ${onlyDigits(phone)}`,
      LeadCategory: isStudent ? "STUDENT" : "PROFESSIONAL",
      LeadSource: "ORGANIC",
      EnrollmentType: "SENIOR PENETRATION TESTER",
      ...(isStudent
        ? {
            CollegeName: demoLeadForm.collegeName.trim(),
            PassedOutYear: demoLeadForm.passedOutYear.trim(),
          }
        : {
            YearsOfExperience: demoLeadForm.yearsOfExperience,
            CompanyName: demoLeadForm.companyName.trim(),
          }),
      AvailabilityBatch: selectedBatch ? selectedBatch.batchStartIso : null,
      BatchDay: selectedBatch ? selectedBatch.batchDay : "",
      CallBack: requestCallback || "NO",
    };

    const endpoint = isStudent
      ? `${CRM_API_URL.replace(/\/$/, "")}/leads/form-student`
      : `${CRM_API_URL.replace(/\/$/, "")}/leads/form-professional`;

    Swal.fire({
      title: "Please wait…",
      html: "Submitting your registration...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      await axios.post(endpoint, payload, {
        timeout: 10000,
        headers: {
          "Content-Type": "application/json",
        },
      });

      Swal.close();

      confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
      });

      await Swal.fire({
        icon: "success",
        title: "Submitted!",
        text: "🎉 Your Upcoming Batch Registration request has been received. We will get back to you.",
        confirmButtonColor: "#1d4ed8",
      });

      setDemoLeadForm({
        fullName: "",
        email: "",
        countryCode: "+91",
        phone: "",
        collegeName: "",
        passedOutYear: "",
        companyName: "",
        yearsOfExperience: "",
      });

      setActiveDemoTab("professional");
      setBatchDayFilter("MORNING");
      setRequestCallback("NO");
      setSelectedDemoBatchKey("");
      setDemoFormErrors({});
      setDemoFormMessage("");
      loadDemoBatches(3);
      navigate("/thank-you-senior");
    } catch (error) {
      console.error("Demo registration failed:", error);

      Swal.close();

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Submission failed";

      await Swal.fire({
        icon: "error",
        title: "Submission failed",
        text: message,
        confirmButtonColor: "#e74c3c",
      });

      setDemoFormMessage(`Submission failed: ${message}`);
    }
  }

  

  function handleInstallmentPayment() {
    if (!selectedInstallmentBatch) {
      Swal.fire({
        icon: "warning",
        title: "Select your batch",
        text: "Please select a batch before proceeding with installment payment.",
        confirmButtonColor: "#1d4ed8",
      });
      return;
    }

    trackEvent("installment_payment_click", {
      amount: fee.FirstInstallmentAmount,
      selected_batch: selectedInstallmentBatch,
    });

    window.open(
      fee.FirstInstallmentLink || DEFAULT_FEE.FirstInstallmentLink,
      "_blank",
      "noopener,noreferrer"
    );
  }

  function getBatchDateInfo(dateValue) {
  const fallback = {
    month: "July",
    day: "23",
    weekday: "Thu",
    displayDate: "23-July-2026",
  };

  if (!dateValue) return fallback;

  const raw = String(dateValue).trim();
  let day;
  let monthIndex;
  let year;

  // Format: 2026-07-23
  const isoMatch = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (isoMatch) {
    year = Number(isoMatch[1]);
    monthIndex = Number(isoMatch[2]) - 1;
    day = Number(isoMatch[3]);
  }

  // Format: 23-July-2026 / 23 - JULY - 2026
  const textMatch = raw
    .replace(/\s*-\s*/g, "-")
    .match(/^(\d{1,2})-([A-Za-z]+)-(\d{4})$/);

  if (!isoMatch && textMatch) {
    const monthMap = {
      january: 0,
      jan: 0,
      february: 1,
      feb: 1,
      march: 2,
      mar: 2,
      april: 3,
      apr: 3,
      may: 4,
      june: 5,
      jun: 5,
      july: 6,
      jul: 6,
      august: 7,
      aug: 7,
      september: 8,
      sep: 8,
      october: 9,
      oct: 9,
      november: 10,
      nov: 10,
      december: 11,
      dec: 11,
    };

    day = Number(textMatch[1]);
    monthIndex = monthMap[textMatch[2].toLowerCase()];
    year = Number(textMatch[3]);
  }

  if (
    !Number.isInteger(day) ||
    !Number.isInteger(monthIndex) ||
    !Number.isInteger(year)
  ) {
    return {
      ...fallback,
      displayDate: raw,
    };
  }

  const date = new Date(year, monthIndex, day);

  if (Number.isNaN(date.getTime())) {
    return {
      ...fallback,
      displayDate: raw,
    };
  }

  const month = date.toLocaleDateString("en-US", { month: "long" });
  const weekday = date.toLocaleDateString("en-US", { weekday: "short" });

  return {
    month,
    day: String(day).padStart(2, "0"),
    weekday,
    displayDate: `${day}-${month}-${year}`,
  };
}

async function handleBrochureSubmit(event) {
  event.preventDefault();

  const errors = {};

  const fullName = brochureForm.name.trim();
  const email = brochureForm.email.trim();
  const phone = brochureForm.phone.trim();

  if (!fullName || fullName.length < 3) {
    errors.name = "Please enter a valid name";
  }

  if (!email || !validateEmailValue(email)) {
    errors.email = "Please enter a valid email";
  }

  const phoneError = validatePhoneValue(phone);
  if (phoneError) {
    errors.phone = phoneError;
  }

  setBrochureErrors(errors);

  if (Object.keys(errors).length > 0) {
    Swal.fire({
      icon: "warning",
      title: "Oops...",
      text: "Please fill out all required fields!",
      confirmButtonColor: "#8e44ad",
    });
    return;
  }

  let selectedCode = brochureForm.countryCode.trim();

  if (!selectedCode.startsWith("+")) {
    selectedCode = `+${selectedCode}`;
  }

  const payload = {
    FullName: fullName,
    Email: email,
    PhoneNumber: `${selectedCode} ${phone}`,
    LeadCategory: "PROFESSIONAL",
    LeadSource: "ORGANIC",
    EnrollmentType: "SENIOR PENETRATION TESTER",
      YearsOfExperience: "2",
      CompanyName: "Download Brochure",
    AvailabilityBatch: "NA",
    BatchDay: "NA",
    CallBack: "YES",
    Message: "Requested brochure download",
  };

  Swal.fire({
    title: "Please Wait...",
    html: "Preparing your brochure...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    await new Promise((resolve) => setTimeout(resolve, 1200));

    await axios.post(
      `${CRM_API_URL.replace(/\/$/, "")}/leads/form-callback-professional`,
      payload,
      {
        timeout: 10000,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    confetti({
      particleCount: 150,
      spread: 70,
      origin: { y: 0.6 },
    });

    Swal.close();

    setBrochureOpen(false);
    setBrochureForm({
      name: "",
      email: "",
      countryCode: "+91",
      phone: "",
    });
    setBrochureErrors({});

    await Swal.fire({
      icon: "success",
      title: "Downloaded!",
      text: "🎉 Detailed syllabus downloaded successfully.",
      confirmButtonColor: "#8e44ad",
    });

    const link = document.createElement("a");
    link.href = seniorBrochurePdf;
    link.download = "senior-Penetration-Tester-Detailed-Syllabus.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    trackEvent("brochure_download_submit", {
      lead_category: "PROFESSIONAL",
      lead_source: "ORGANIC",
    });
  } catch (error) {
    console.error("Brochure download failed:", error);

    Swal.close();

    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Something went wrong. Please try again later.";

    Swal.fire({
      icon: "error",
      title: "Error",
      text: message,
      confirmButtonColor: "#e74c3c",
    });
  }
}

  return (
    <main className="overflow-x-hidden bg-slate-50 text-slate-950">
      {/* HERO */}
{/* HERO - SENIOR PENETRATION TESTER */}
<header className="relative overflow-hidden bg-[#070A12]">
  {/* Background Layers */}
  <div className="absolute inset-0">
    {/* Premium radial glow */}
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(220,38,38,0.28),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(124,58,237,0.30),transparent_36%),radial-gradient(circle_at_center,rgba(245,158,11,0.10),transparent_45%)]"></div>

    {/* Cyber grid */}
    <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.045)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.045)_1px,transparent_1px)] bg-[size:44px_44px] opacity-30"></div>

    {/* Right premium polygon */}
    <div
      className="absolute top-0 right-0 h-full w-[60%] bg-gradient-to-br from-red-700 via-purple-800 to-slate-950 opacity-95"
      style={{
        clipPath: "polygon(28% 0%, 100% 0%, 100% 100%, 0% 100%)",
      }}
    ></div>

    {/* Bottom shadow */}
    <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black/60 to-transparent"></div>
  </div>

  <section className="relative z-10 px-4 pt-12 pb-12 md:px-20 md:pt-20">
    <div className="grid items-center gap-12 mx-auto max-w-7xl lg:grid-cols-2">
      {/* LEFT CONTENT */}
      <div className="space-y-7">
        <div className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black tracking-widest text-red-200 uppercase border rounded-full bg-white/10 border-white/15 backdrop-blur">
          <span className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></span>
          Advanced Cybersecurity Career Program
        </div>

        <div>
          <p className="text-lg font-black tracking-widest uppercase text-amber-300">
            Advanced Application Security / VAPT
          </p>

          <h1 className="mt-3 text-4xl font-black leading-tight text-white md:text-6xl">
            Senior Penetration{" "}
            <span className="text-transparent bg-gradient-to-r from-red-300 via-amber-300 to-purple-300 bg-clip-text">
              Tester
            </span>
          </h1>
        </div>

        <p className="max-w-2xl text-lg font-medium leading-8 text-slate-300">
          The Senior Penetration Tester program is built for learners who want
          to move into advanced VAPT, application security, API security, cloud
          security, and real-world offensive security roles. This track focuses
          on advanced technical depth, practical exploitation, reporting, and
          enterprise-grade security assessment workflows.
        </p>

        {/* Highlights */}
        <div className="flex flex-wrap gap-3">
          <span className="px-4 py-2 text-sm font-bold text-white border rounded-full bg-white/10 border-white/15">
            Advanced VAPT
          </span>

          <span className="px-4 py-2 text-sm font-bold text-white border rounded-full bg-white/10 border-white/15">
            API Security
          </span>

          <span className="px-4 py-2 text-sm font-bold text-white border rounded-full bg-white/10 border-white/15">
            Cloud Labs
          </span>

          <span className="px-4 py-2 text-sm font-bold text-white border rounded-full bg-white/10 border-white/15">
            Real Client Scenarios
          </span>

          <span className="px-4 py-2 text-sm font-bold text-white border rounded-full bg-white/10 border-white/15">
            Mock Interviews
          </span>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col gap-4 pt-2 sm:flex-row">
          <button
            type="button"
            onClick={() => setCallbackOpen(true)}
            className="inline-flex items-center justify-center px-8 py-4 text-base font-black text-white transition shadow-xl rounded-xl bg-gradient-to-r from-red-600 via-purple-700 to-blue-700 shadow-red-900/30 hover:scale-105 hover:shadow-2xl"
          >
            Get a Call Back
          </button>

          <button
            type="button"
            onClick={scrollToDemoRegistration}
            className="inline-flex items-center justify-center px-8 py-4 text-base font-black text-white transition border rounded-xl border-white/20 bg-white/10 backdrop-blur hover:bg-white hover:text-slate-950"
          >
            Demo Registration
          </button>
        </div>

        {/* Price */}
        <div className="flex flex-wrap items-center gap-5 pt-3">
          <div className="px-6 py-4 border shadow-2xl rounded-2xl bg-white/10 border-white/15 backdrop-blur">
            <p className="text-xs font-black tracking-widest uppercase text-slate-300">
              Course Fee
            </p>

            <p className="mt-1 text-3xl font-black text-white">
              {formatCurrency(fee.AfterOfferCourseFee || 19000)}
            </p>
          </div>

          <div>
            <span className="inline-flex px-3 py-1 text-sm font-black border rounded-full text-amber-300 bg-amber-500/10 border-amber-400/20">
              {fee.DiscountPercentage || 24}% OFF
            </span>

            <p className="mt-2 text-base font-bold line-through text-slate-400">
              {formatCurrency(fee.TotalCourseFee || 25000)}
            </p>

            <p className="text-xs font-semibold text-slate-500">
              (*Incl. Taxes)
            </p>
          </div>
        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div className="relative">
        <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-r from-red-500/40 via-purple-500/40 to-amber-400/30 blur-2xl"></div>

        <div className="relative p-3 border shadow-2xl bg-white/10 border-white/20 rounded-[2rem] backdrop-blur">
          <img
            src={heroImage}
            alt="Senior Penetration Tester Training"
            className="object-cover w-full h-auto shadow-2xl rounded-[1.5rem]"
          />

          {/* Floating Badge */}
          <div className="absolute left-6 right-6 bottom-6">
            <div className="p-4 border shadow-xl bg-slate-950/90 border-white/10 rounded-2xl backdrop-blur">
              <div className="flex items-center justify-between gap-4">
                <div>
                  <p className="text-xs font-black tracking-widest uppercase text-amber-300">
                    Next Cohort Starts
                  </p>

                  <p className="mt-1 text-lg font-black text-white">
                    {getDisplayDate(latestCohort.BatchStartDate)}
                  </p>
                </div>

                <span className="px-4 py-2 text-xs font-black text-green-300 border rounded-full bg-green-500/10 border-green-400/20">
                  Seats Open
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* INFO CARDS */}
    <div className="grid gap-4 mx-auto mt-12 max-w-7xl sm:grid-cols-2 lg:grid-cols-4">
      {/* Card 1 */}
      <div className="p-5 border shadow-xl bg-white/95 border-slate-200 rounded-2xl">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-12 h-12 text-red-700 bg-red-100 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <div>
            <p className="text-sm font-bold text-slate-500">
              Next Cohort Starts
            </p>
            <p className="text-base font-black text-green-600">
              {getDisplayDate(latestCohort.BatchStartDate)}
            </p>
          </div>
        </div>
      </div>

      {/* Card 2 */}
      <div className="p-5 border shadow-xl bg-white/95 border-slate-200 rounded-2xl">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-12 h-12 text-purple-700 bg-purple-100 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M8 7V3m8 4V3M3 11h18M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>

          <div>
            <p className="text-sm font-bold text-slate-500">Class Days</p>
            <p className="text-base font-black text-slate-950">
              {latestCohort.Sessions || "MON - FRI"}
            </p>
          </div>
        </div>
      </div>

      {/* Card 3 */}
      <div className="p-5 border shadow-xl bg-white/95 border-slate-200 rounded-2xl">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-12 h-12 text-amber-700 bg-amber-100 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z"
              />
            </svg>
          </div>

          <div>
            <p className="text-sm font-bold text-slate-500">
              Program Duration
            </p>
            <p className="text-base font-black text-slate-950">
              {latestCohort.Duration || "2 Months"}
            </p>
          </div>
        </div>
      </div>

      {/* Card 4 */}
      <div className="p-5 border shadow-xl bg-white/95 border-slate-200 rounded-2xl">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-12 h-12 text-cyan-700 bg-cyan-100 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 20l9-5-9-5-9 5 9 5z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 12V4"
              />
            </svg>
          </div>

          <div>
            <p className="text-sm font-bold text-slate-500">
              Learning Format
            </p>
            <p className="text-base font-black text-slate-950">
              {latestCohort.Mode
                ? `${latestCohort.Mode}, Advanced Practical`
                : "Live/Online, Advanced Practical"}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</header>

    {/* WATCH RECENT DEMO */}
<section className="relative px-4 py-8 overflow-hidden bg-slate-50 md:px-20">
  {/* Background Decoration */}
  <div className="absolute top-0 right-0 rounded-full w-72 h-72 bg-blue-200/40 blur-3xl"></div>
  <div className="absolute bottom-0 left-0 rounded-full w-72 h-72 bg-cyan-200/30 blur-3xl"></div>

  <div className="relative z-10 mx-auto max-w-7xl">
    {/* Header */}
    <div className="max-w-4xl mx-auto text-center">
      <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 border border-blue-200 rounded-full shadow-sm">
        <span className="w-2 h-2 bg-blue-700 rounded-full animate-pulse"></span>
        Free Demo Session
      </span>

      <h2 className="mt-5 text-3xl font-black tracking-tight text-slate-950 md:text-5xl">
        Watch Our Recent{" "}
        <span className="text-blue-700">Live Demo Session</span>
      </h2>

      <p className="max-w-6xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-600">
        Experience how our live practical VAPT training works before enrolling.
        Register to access the latest demo recording and understand our training
        methodology, instructor quality, and hands-on lab approach.
      </p>
    </div>

    {/* Trust Cards */}
    <div className="grid max-w-5xl grid-cols-1 gap-4 mx-auto mt-10 sm:grid-cols-3">
      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-3xl font-black text-blue-700">Live</p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Instructor-Led Training
        </p>
      </div>

      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-3xl font-black text-green-700">
          {latestCohort.SeatsAvailable || "Available"}
        </p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Enrollment Seats
        </p>
      </div>

      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-3xl font-black text-purple-700">VAPT</p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Practical Demo Recording
        </p>
      </div>
    </div>

    {/* Desktop Table */}
    <div className="hidden mt-12 overflow-hidden bg-white border shadow-2xl md:block rounded-3xl border-slate-200">
      <div className="px-6 py-5 bg-gradient-to-r from-slate-950 via-blue-950 to-slate-950">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-xl font-black text-white">
              Latest Demo Recording Access
            </h3>
            {/* <p className="mt-1 text-sm font-semibold text-blue-100">
              Register once and our team will share the demo access details.
            </p> */}
          </div>

          <span className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black text-green-300 border rounded-full bg-green-500/10 border-green-400/30">
            <span className="w-2 h-2 bg-green-400 rounded-full"></span>
            Registration Open
          </span>
        </div>
      </div>

      <table className="min-w-full text-sm">
        <thead>
          <tr className="bg-slate-100 text-slate-700">
            <th className="px-6 py-4 text-xs font-black tracking-widest text-left uppercase">
              Demo Details
            </th>
            <th className="px-6 py-4 text-xs font-black tracking-widest text-left uppercase">
              Upcoming Batch
            </th>
            <th className="px-6 py-4 text-xs font-black tracking-widest text-left uppercase">
              Seats Status
            </th>
            <th className="px-6 py-4 text-xs font-black tracking-widest text-right uppercase">
              Action
            </th>
          </tr>
        </thead>

        <tbody>
          {demoRows.map((row) => (
            <tr
              key={row.title}
              className="transition border-t border-slate-100 hover:bg-blue-50/50"
            >
              <td className="px-6 py-6">
                <div className="flex items-start gap-4">
                  <div className="relative flex items-center justify-center text-xl text-white bg-blue-700 shadow-lg w-14 h-14 rounded-2xl shadow-blue-700/20">
                    ▶
                    <span className="absolute w-4 h-4 bg-green-500 border-2 border-white rounded-full -right-1 -top-1"></span>
                  </div>

                  <div>
                    <h3 className="text-lg font-black text-slate-950">
                      {row.title}
                    </h3>

                    <p className="max-w-xl mt-1 text-sm font-semibold leading-6 text-slate-600">
                      Watch the latest practical walkthrough from our expert
                      instructor and understand the learning experience before
                      joining the program.
                    </p>

                    <div className="flex flex-wrap items-center gap-2 mt-3">
                      <span className="px-3 py-1 text-xs font-black text-blue-700 rounded-full bg-blue-50">
                        Senior Penetration Tester
                      </span>

                      <span className="px-3 py-1 text-xs font-black text-purple-700 rounded-full bg-purple-50">
                        Application Security / VAPT
                      </span>
                    {/* <span className="px-3 py-1 text-xs font-black text-red-700 rounded-full bg-purple-50">
                        Mobile Penetration Testing
                      </span>
                      <span className="px-3 py-1 text-xs font-black text-green-700 rounded-full bg-purple-50">
                        API Penetration Testing
                      </span>
                      <span className="px-3 py-1 text-xs font-black text-orange-700 rounded-full bg-purple-50">
                        Thick Client Penetration Testing
                      </span> */}
                    </div>
                  </div>
                </div>
              </td>

              <td className="px-6 py-6">
                <div>
                  <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                    Batch Starts
                  </p>

                  <p className="mt-1 text-base font-black text-slate-950">
                    {getDisplayDate(latestCohort.BatchStartDate)}
                  </p>

                  <p className="mt-1 text-sm font-semibold text-slate-500">
                    {latestCohort.Timings || "07:00 AM TO 08:00 AM"}
                  </p>
                </div>
              </td>

              <td className="px-6 py-6">
  <span className="relative inline-flex items-center gap-2 px-4 py-2 overflow-hidden text-xs font-black text-black border rounded-md shadow-lg bg-gradient-to-r from-pink-500 via-yellow-400 to-green-500 border-white/40 animate-confetti-blink">
    {/* Confetti dots */}
    <span className="absolute w-1.5 h-1.5 bg-red-500 rounded-full top-1 left-3 animate-confetti-dot"></span>
    <span className="absolute w-1.5 h-1.5 bg-blue-500 rounded-full top-2 right-4 animate-confetti-dot-delay"></span>
    <span className="absolute w-1.5 h-1.5 bg-yellow-300 rounded-full bottom-1 left-8 animate-confetti-dot"></span>
    <span className="absolute w-1.5 h-1.5 bg-purple-500 rounded-full bottom-2 right-8 animate-confetti-dot-delay"></span>

   

    <span className="relative z-10 drop-shadow-sm">
      {latestCohort.SeatsAvailable || "Available"}
    </span>
  </span>
</td>

              <td className="px-6 py-6 text-right">
                <button
  type="button"
  onClick={goToDemoRegistrationPage}
  className="inline-flex items-center justify-center px-6 py-3 text-sm font-black text-white transition bg-blue-700 shadow-lg rounded-xl shadow-blue-700/20 hover:bg-blue-800 hover:-translate-y-0.5"
>
  Watch Demo →
</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* Mobile Cards */}
    <div className="grid gap-5 mt-10 md:hidden">
      {demoRows.map((row) => (
        <div
          key={row.title}
          className="overflow-hidden bg-white border shadow-xl rounded-3xl border-slate-200"
        >
          <div className="px-5 py-4 bg-gradient-to-r from-slate-950 to-blue-950">
            <div className="flex items-center justify-between">
              <span className="text-xs font-black tracking-widest text-blue-200 uppercase">
                Demo Access
              </span>

              <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-black text-green-300 rounded-full bg-green-500/10">
                <span className="w-2 h-2 bg-green-400 rounded-full"></span>
                Open
              </span>
            </div>
          </div>

          <div className="p-5">
            <div className="flex items-start gap-4">
              <div className="flex items-center justify-center text-xl text-white bg-blue-700 shadow-lg w-14 h-14 rounded-2xl shadow-blue-700/20">
                ▶
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-black leading-snug text-slate-950">
                  {row.title}
                </h3>

                <p className="mt-2 text-sm font-semibold leading-6 text-slate-600">
                  Register to access the recent demo recording and understand
                  the practical VAPT learning experience.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 mt-5">
              <div className="p-3 rounded-2xl bg-slate-50">
                <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                  Batch Starts
                </p>
                <p className="mt-1 text-sm font-black text-blue-700">
                  {getDisplayDate(latestCohort.BatchStartDate)}
                </p>
              </div>

              <div className="relative p-3 overflow-hidden border shadow-lg rounded-2xl bg-gradient-to-r from-pink-500 via-yellow-400 to-green-500 border-white/40 animate-confetti-blink">
  {/* Confetti dots */}
  <span className="absolute w-1.5 h-1.5 bg-red-500 rounded-full top-1 left-3 animate-confetti-dot"></span>
  <span className="absolute w-1.5 h-1.5 bg-blue-500 rounded-full top-2 right-4 animate-confetti-dot-delay"></span>
  <span className="absolute w-1.5 h-1.5 bg-yellow-300 rounded-full bottom-1 left-8 animate-confetti-dot"></span>
  <span className="absolute w-1.5 h-1.5 bg-purple-500 rounded-full bottom-2 right-8 animate-confetti-dot-delay"></span>

  <p className="relative z-10 text-xs font-black tracking-widest text-black uppercase drop-shadow-sm">
    Seats
  </p>

  <div className="relative z-10 flex items-center gap-2 mt-1">
    <span className="w-2.5 h-2.5 bg-white rounded-full animate-ping"></span>

    <p className="text-sm font-black text-black drop-shadow-sm">
      {latestCohort.SeatsAvailable || "Available"}
    </p>
  </div>
</div>
            </div>

            <button
  type="button"
  onClick={goToDemoRegistrationPage}
  className="inline-flex items-center justify-center px-6 py-3 text-sm font-black text-white transition bg-blue-700 shadow-lg rounded-xl shadow-blue-700/20 hover:bg-blue-800 hover:-translate-y-0.5"
>
  Watch Demo →
</button>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


<AlumniSuccessStories />


     {/* OUR EDTECH PLATFORM SECTION */}
<section className="relative z-10 px-4 py-20 overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-white md:px-20">
  {/* Background Effects */}
  <div className="absolute top-0 right-0 rounded-full w-96 h-96 bg-blue-200/40 blur-3xl"></div>
  <div className="absolute bottom-0 left-0 rounded-full w-96 h-96 bg-cyan-200/30 blur-3xl"></div>

  <div className="relative z-10 mx-auto max-w-7xl">
    {/* Section Heading */}
    <div className="max-w-5xl mx-auto text-center mb-14">
      <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 border border-blue-200 rounded-full shadow-sm">
        <span className="w-2 h-2 bg-blue-700 rounded-full animate-pulse"></span>
        Practical Infosec Learning Platform
      </span>

      <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
        Our <span className="text-blue-700">EdTech Platform</span> Offers You
      </h2>

      <p className="max-w-5xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-600">
        Practical learning meets real-world cybersecurity training. Our platform
        is designed to help students gain hands-on experience, industry exposure,
        and job-ready skills through live interactive sessions, cloud labs,
        recordings, mentor support, and career-focused learning.
      </p>
    </div>

    {/* Main Layout */}
    <div className="grid items-start grid-cols-1 gap-8 lg:grid-cols-3">
      {/* LEFT SIDE - BIG VIDEO */}
      <div className="relative lg:col-span-2">
        <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/30 via-cyan-400/20 to-purple-500/20 blur-2xl rounded-[2rem]"></div>

        <div className="relative overflow-hidden bg-white border shadow-2xl rounded-[2rem] border-slate-200">
          {/* Video Header */}
          <div className="flex items-center justify-between px-5 py-4 border-b bg-slate-950 border-slate-800">
            <div>
              <p className="text-xs font-black tracking-widest uppercase text-cyan-300">
                Platform Walkthrough
              </p>
              <h3 className="mt-1 text-lg font-black text-white">
                Learn. Practice. Get Job Ready.
              </h3>
            </div>

            <span className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black text-green-300 border rounded-full bg-green-500/10 border-green-400/30">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
              Live Platform
            </span>
          </div>

          {/* Video Container */}
          <div className="relative overflow-hidden bg-black border border-gray-200 shadow-2xl rounded-xl">
            {/* Glow */}
            <div className="absolute inset-0 z-10 pointer-events-none"></div>

            {/* Video */}
            <video
              className="w-full h-[600px] object-cover rounded-lg"
              autoPlay
              muted
              loop
              playsInline
              controlsList="nodownload noplaybackrate"
              disablePictureInPicture
            >
              <source src={edtechPlatformVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Bottom Stats */}
          <div className="grid grid-cols-1 gap-3 p-5 bg-white sm:grid-cols-3">
            <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
              <p className="text-2xl font-black text-blue-700">2 Years</p>
              <p className="mt-1 text-sm font-bold text-slate-600">
                Recording Access
              </p>
            </div>

            <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
              <p className="text-2xl font-black text-cyan-700">1 Year</p>
              <p className="mt-1 text-sm font-bold text-slate-600">
                Cloud Lab Access
              </p>
            </div>

            <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
              <p className="text-2xl font-black text-purple-700">24/7</p>
              <p className="mt-1 text-sm font-bold text-slate-600">
                Chat Support
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE - DETAILS */}
      <div className="space-y-4">
        {/* Card 1 */}
        <div className="relative p-5 overflow-hidden transition duration-300 bg-white border shadow-xl group rounded-3xl border-slate-200 hover:-translate-y-1 hover:shadow-2xl">
          <div className="absolute top-0 bottom-0 left-0 w-1.5 bg-orange-500"></div>

          <div className="flex items-start gap-4">
            <div className="flex items-center justify-center bg-orange-100 w-14 h-14 rounded-2xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-orange-500 w-7 h-7"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 14l9-5-9-5-9 5 9 5z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 14l6.16-3.422A12.083 12.083 0 0112 20.055a12.083 12.083 0 01-6.16-9.477L12 14z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 14v7"
                />
              </svg>
            </div>

            <div>
              <h3 className="text-lg font-black text-slate-950">
                Instructor Led Live Sessions
              </h3>
              <p className="mt-1 text-sm font-semibold leading-6 text-slate-600">
                Learn directly from cybersecurity practitioners through live,
                interactive, doubt-clearing sessions.
              </p>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="relative p-5 overflow-hidden transition duration-300 bg-white border shadow-xl group rounded-3xl border-slate-200 hover:-translate-y-1 hover:shadow-2xl">
          <div className="absolute top-0 bottom-0 left-0 w-1.5 bg-red-500"></div>

          <div className="flex items-start gap-4">
            <div className="flex items-center justify-center bg-red-100 w-14 h-14 rounded-2xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-red-500 w-7 h-7"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2z"
                />
              </svg>
            </div>

            <div>
              <h3 className="text-lg font-black text-slate-950">
                Access to Recordings - 2 Years
              </h3>
              <p className="mt-1 text-sm font-semibold leading-6 text-slate-600">
                Revisit every class anytime with long-term access to session
                recordings and revision material.
              </p>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="relative p-5 overflow-hidden transition duration-300 bg-white border shadow-xl group rounded-3xl border-slate-200 hover:-translate-y-1 hover:shadow-2xl">
          <div className="absolute top-0 bottom-0 left-0 w-1.5 bg-cyan-600"></div>

          <div className="flex items-start gap-4">
            <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-cyan-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-7 h-7 text-cyan-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 15a4 4 0 014-4h1a5 5 0 019.9-1A4.5 4.5 0 0118.5 19H7a4 4 0 01-4-4z"
                />
              </svg>
            </div>

            <div>
              <h3 className="text-lg font-black text-slate-950">
                Cloud Hosted Labs - 1 Year
              </h3>
              <p className="mt-1 text-sm font-semibold leading-6 text-slate-600">
                Practice security testing in dedicated cloud labs without local
                setup complexity.
              </p>
            </div>
          </div>
        </div>

        {/* Card 4 */}
        <div className="relative p-5 overflow-hidden transition duration-300 bg-white border shadow-xl group rounded-3xl border-slate-200 hover:-translate-y-1 hover:shadow-2xl">
          <div className="absolute top-0 bottom-0 left-0 w-1.5 bg-purple-600"></div>

          <div className="flex items-start gap-4">
            <div className="flex items-center justify-center bg-purple-100 w-14 h-14 rounded-2xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-purple-600 w-7 h-7"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012 2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-4 4v-4z"
                />
              </svg>
            </div>

            <div>
              <h3 className="text-lg font-black text-slate-950">
                1:1 Mock Interviews
              </h3>
              <p className="mt-1 text-sm font-semibold leading-6 text-slate-600">
                Prepare for real interviews with role-focused mock sessions and
                practical feedback.
              </p>
            </div>
          </div>
        </div>

        {/* Card 5 */}
        <div className="relative p-5 overflow-hidden transition duration-300 bg-white border shadow-xl group rounded-3xl border-slate-200 hover:-translate-y-1 hover:shadow-2xl">
          <div className="absolute top-0 bottom-0 left-0 w-1.5 bg-indigo-600"></div>

          <div className="flex items-start gap-4">
            <div className="flex items-center justify-center bg-indigo-100 w-14 h-14 rounded-2xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-indigo-600 w-7 h-7"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12h6m-6 4h6M8 7h8m3 13H5a2 2 0 01-2-2V6a2 2 0 012-2h3.586a1 1 0 00.707-.293l1.414-1.414A1 1 0 0111.414 2h1.172a1 1 0 01.707.293l1.414 1.414A1 1 0 0016.414 4H20a2 2 0 012 2v12a2 2 0 01-2 2z"
                />
              </svg>
            </div>

            <div>
              <h3 className="text-lg font-black text-slate-950">
                Dedicated Job Portal
              </h3>
              <p className="mt-1 text-sm font-semibold leading-6 text-slate-600">
                Access cybersecurity openings, career opportunities, and
                placement-focused support.
              </p>
            </div>
          </div>
        </div>

        {/* Card 6 */}
        <div className="relative p-5 overflow-hidden transition duration-300 bg-white border shadow-xl group rounded-3xl border-slate-200 hover:-translate-y-1 hover:shadow-2xl">
          <div className="absolute top-0 bottom-0 left-0 w-1.5 bg-emerald-600"></div>

          <div className="flex items-start gap-4">
            <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-emerald-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-7 h-7 text-emerald-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8L3 20l1.3-3.9A7.93 7.93 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
            </div>

            <div>
              <h3 className="text-lg font-black text-slate-950">
                24/7 Chat Support
              </h3>
              <p className="mt-1 text-sm font-semibold leading-6 text-slate-600">
                Get continuous support for lab issues, course doubts, and
                learning guidance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom Enterprise Note */}
    <div className="grid grid-cols-1 gap-4 mt-10 md:grid-cols-3">
      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-2xl font-black text-blue-700">Hands-on</p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Learn by practicing real-world security scenarios
        </p>
      </div>

      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-2xl font-black text-purple-700">Career Ready</p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Build interview-ready and job-ready practical skills
        </p>
      </div>

      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-2xl font-black text-cyan-700">Mentor Support</p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Guided learning from industry security professionals
        </p>
      </div>
    </div>
  </div>
</section>


     {/* UPCOMING BATCHES + DEMO REGISTRATION */}
<section
  id="upcomingBatches"
  className="relative px-4 py-10 overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-white md:px-20"
>
  {/* Background Effects */}
  <div className="absolute top-0 right-0 rounded-full w-96 h-96 bg-blue-200/40 blur-3xl"></div>
  <div className="absolute bottom-0 left-0 rounded-full w-96 h-96 bg-cyan-200/30 blur-3xl"></div>

  <div className="relative z-10 mx-auto max-w-7xl">
    {/* Header */}
    <div className="max-w-5xl mx-auto mb-12 text-center">
      <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 border border-blue-200 rounded-full shadow-sm">
        <span className="w-2 h-2 bg-blue-700 rounded-full animate-pulse"></span>
        Upcoming Live Cohorts
      </span>

      <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
        Choose Your Preferred{" "}
        <span className="text-blue-700">Training Batch</span>
      </h2>

      <p className="max-w-6xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-600">
        Select your preferred batch, register your interest, and our admissions
        team will help you with the next steps for enrollment.
      </p>
    </div>

    {/* Side by Side Layout */}
    <div className="grid items-start gap-8 lg:grid-cols-[1.1fr_0.9fr]">
      {/* LEFT SIDE - BATCH DETAILS */}
      <div className="space-y-6">
        <div className="overflow-hidden bg-white border shadow-2xl rounded-3xl border-slate-200">
          <div className="px-6 py-5 bg-gradient-to-r from-slate-950 via-blue-950 to-slate-950">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p className="text-xs font-black tracking-widest uppercase text-cyan-300">
                  Practical Infosec Certified Program
                </p>

                <h3 className="mt-1 text-xl font-black text-white">
                  Senior Penetration Tester - Upcoming Batches
                </h3>
              </div>

              <span className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black text-green-300 border rounded-full bg-green-500/10 border-green-400/30">
                <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                Enrollment Open
              </span>
            </div>
          </div>

          <div className="p-5 space-y-5">
            {(cohorts && cohorts.length > 0 ? cohorts : DEFAULT_COHORTS).map(
              (cohort) => {
                const dateInfo = getBatchDateInfo(cohort.BatchStartDate);

                return (
                  <div
                    key={
                      cohort.id ||
                      `${cohort.BatchStartDate}-${cohort.BatchType}`
                    }
                    className="overflow-hidden transition bg-white border shadow-lg rounded-3xl border-slate-200 hover:shadow-2xl hover:-translate-y-1"
                  >
                    <div className="grid grid-cols-1 lg:grid-cols-[190px_1fr]">
                      {/* Date Block */}
                      <div className="flex items-center justify-center p-6 bg-gradient-to-br from-blue-700 to-slate-950">
                        <div className="w-full max-w-[150px] overflow-hidden bg-white shadow-2xl rounded-2xl">
                          <div className="px-4 py-2 text-sm font-black tracking-widest text-center text-blue-900 uppercase bg-white border-b border-slate-200">
                            {dateInfo.month}
                          </div>

                          <div className="px-4 py-5 text-center text-white bg-blue-900">
                            <span className="block text-4xl font-black">
                              {dateInfo.day}
                            </span>
                            <span className="block mt-1 text-sm font-bold tracking-widest uppercase">
                              {dateInfo.weekday}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Details Block */}
                      <div className="p-6">
                        <div className="flex flex-col gap-4 mb-5 sm:flex-row sm:items-start sm:justify-between">
                          <div>
                            <h4 className="text-xl font-black text-slate-950">
                              {cohort.BatchType || "MORNING"} Batch
                            </h4>

                            <p className="mt-1 text-sm font-semibold text-slate-600">
                              Live online practical cybersecurity training
                            </p>
                          </div>

                          <div className="flex items-center gap-2 mt-3">
  

  <span className="relative inline-flex items-center gap-2 px-4 py-2 overflow-hidden text-xs font-black text-white border rounded-md shadow-lg bg-gradient-to-r from-pink-500 via-yellow-400 to-green-500 border-white/40 animate-confetti-blink">
    {/* Confetti dots */}
    <span className="absolute w-1.5 h-1.5 bg-red-500 rounded-full top-1 left-3 animate-confetti-dot"></span>
    <span className="absolute w-1.5 h-1.5 bg-blue-500 rounded-full top-2 right-4 animate-confetti-dot-delay"></span>
    <span className="absolute w-1.5 h-1.5 bg-yellow-300 rounded-full bottom-1 left-8 animate-confetti-dot"></span>
    <span className="absolute w-1.5 h-1.5 bg-purple-500 rounded-full bottom-2 right-8 animate-confetti-dot-delay"></span>

   

    <span className="relative z-10 text-black drop-shadow-sm">
      {cohort.SeatsAvailable || "14 Available"}
    </span>
  </span>
</div>
                        </div>

                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                          <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Batch Start Date
                            </p>
                            <p className="mt-1 text-base font-black text-slate-950">
                              {dateInfo.displayDate}
                            </p>
                          </div>

                          <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Batch End Date
                            </p>
                            <p className="mt-1 text-base font-black text-slate-950">
                              {getDisplayDate(
                                cohort.BatchEndDate,
                                "11-September-2026"
                              )}
                            </p>
                          </div>

                          <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Duration
                            </p>
                            <p className="mt-1 text-base font-black text-slate-950">
                              {cohort.Duration || "1.5 Months"}
                            </p>
                          </div>

                          <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Mode
                            </p>
                            <p className="mt-1 text-base font-black text-blue-700">
                              {cohort.Mode || "LIVE/ONLINE"}
                            </p>
                          </div>

                          <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Time
                            </p>
                            <p className="mt-1 text-base font-black text-slate-950">
                              {cohort.Timings || "07:00 AM TO 08:00 AM"}
                            </p>
                          </div>

                          <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Sessions
                            </p>
                            <p className="mt-1 text-base font-black text-slate-950">
                              {cohort.Sessions || "MONDAY to FRIDAY"}
                            </p>
                          </div>

                          <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Language
                            </p>
                            <p className="mt-1 text-base font-black text-slate-950">
                              {cohort.Language || "ENGLISH"}
                            </p>
                          </div>

                          <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Learning Platform
                            </p>
                            <p className="mt-1 text-base font-black text-slate-950">
                              {cohort.LearningPlatform ||
                                "Practical Infosec LMS"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </div>
        </div>

        {/* Left Bottom Info */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
            <p className="text-2xl font-black text-blue-700">Live</p>
            <p className="mt-1 text-sm font-bold text-slate-600">
              Instructor-Led Classes
            </p>
          </div>

          <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
            <p className="text-2xl font-black text-purple-700">Labs</p>
            <p className="mt-1 text-sm font-bold text-slate-600">
              Practical Assignments
            </p>
          </div>

          <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
            <p className="text-2xl font-black text-cyan-700">Career</p>
            <p className="mt-1 text-sm font-bold text-slate-600">
              Job-Focused Training
            </p>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE - FORM */}
      <main
        id="demoRegistration"
        className="w-full overflow-hidden bg-white border shadow-2xl lg:sticky lg:top-24 rounded-3xl border-slate-200"
      >
        {/* Form Header */}
        <div className="relative px-6 py-6 overflow-hidden bg-gradient-to-r from-slate-950 via-blue-950 to-slate-950">
          <div className="absolute inset-0 bg-blue-500/10"></div>

          <div className="relative">
            <span className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black tracking-widest uppercase border rounded-full text-cyan-300 bg-white/5 border-white/10">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
              Registration
            </span>

            <h2 className="mt-4 text-3xl font-black tracking-tight text-white">
              Register Now
            </h2>

            <p className="mt-2 text-sm font-semibold leading-6 text-blue-100">
              Fill in your details and select your preferred batch. Our team
              will contact you with demo and enrollment details.
            </p>
          </div>
        </div>

        <form
          onSubmit={handleDemoRegistrationSubmit}
          className="p-5 space-y-5 sm:p-6"
          noValidate
        >
          {/* Name + Email */}
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
              <label className="block mb-1 text-sm font-black tracking-wide text-slate-800">
                Full Name
              </label>

              <input
                name="fullName"
                required
                minLength={2}
                placeholder="Jane Doe"
                value={demoLeadForm.fullName}
                onChange={(event) =>
                  setDemoLeadForm({
                    ...demoLeadForm,
                    fullName: event.target.value,
                  })
                }
                className={`w-full px-4 py-3 text-base font-semibold border rounded-xl shadow-sm outline-none transition focus:ring-4 focus:ring-blue-100 ${
                  demoFormErrors.fullName
                    ? "border-red-500"
                    : "border-slate-200 focus:border-blue-500"
                }`}
              />

              {demoFormErrors.fullName && (
                <p className="mt-1 text-sm font-semibold text-red-600">
                  {demoFormErrors.fullName}
                </p>
              )}
            </div>

            <div>
              <label className="block mb-1 text-sm font-black tracking-wide text-slate-800">
                Email
              </label>

              <input
                name="email"
                required
                placeholder="you@example.com"
                value={demoLeadForm.email}
                onChange={(event) =>
                  setDemoLeadForm({
                    ...demoLeadForm,
                    email: event.target.value,
                  })
                }
                className={`w-full px-4 py-3 text-base font-semibold border rounded-xl shadow-sm outline-none transition focus:ring-4 focus:ring-blue-100 ${
                  demoFormErrors.email
                    ? "border-red-500"
                    : "border-slate-200 focus:border-blue-500"
                }`}
              />

              {demoFormErrors.email && (
                <p className="mt-1 text-sm font-semibold text-red-600">
                  {demoFormErrors.email}
                </p>
              )}
            </div>
          </div>

          {/* Phone */}
          <div>
            <label className="block mb-1 text-sm font-black tracking-wide text-slate-800">
              Phone Number
            </label>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-[150px_1fr]">
              <select
                value={demoLeadForm.countryCode}
                onChange={(event) =>
                  setDemoLeadForm({
                    ...demoLeadForm,
                    countryCode: event.target.value,
                  })
                }
                className="w-full px-3 py-3 text-sm font-bold border shadow-sm outline-none rounded-xl border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
              >
                {COUNTRY_CODES.map((country) => (
                  <option
                    key={`${country.name}-${country.code}`}
                    value={country.code}
                  >
                    {country.name} ({country.code})
                  </option>
                ))}
              </select>

              <div>
                <input
                  name="phone"
                  placeholder="Mobile number"
                  value={demoLeadForm.phone}
                  onChange={(event) =>
                    setDemoLeadForm({
                      ...demoLeadForm,
                      phone: event.target.value,
                    })
                  }
                  className={`w-full px-4 py-3 text-base font-semibold border rounded-xl shadow-sm outline-none transition focus:ring-4 focus:ring-blue-100 ${
                    demoFormErrors.phone
                      ? "border-red-500"
                      : "border-slate-200 focus:border-blue-500"
                  }`}
                />

                {demoFormErrors.phone && (
                  <p className="mt-1 text-sm font-semibold text-red-600">
                    {demoFormErrors.phone}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Student / Professional Tabs */}
          <div>
            <label className="block mb-2 text-sm font-black tracking-wide text-slate-800">
              I am a
            </label>

            <div className="grid grid-cols-2 gap-2 p-1 border rounded-2xl bg-slate-100 border-slate-200">
              <button
                type="button"
                onClick={() => {
                  setActiveDemoTab("student");
                  setDemoLeadForm({
                    ...demoLeadForm,
                    companyName: "",
                    yearsOfExperience: "",
                  });
                }}
                className={`px-4 py-3 rounded-xl font-black cursor-pointer transition ${
                  activeDemoTab === "student"
                    ? "bg-blue-700 text-white shadow-lg"
                    : "bg-transparent text-slate-700 hover:bg-white"
                }`}
              >
                Student
              </button>

              <button
                type="button"
                onClick={() => {
                  setActiveDemoTab("professional");
                  setDemoLeadForm({
                    ...demoLeadForm,
                    collegeName: "",
                    passedOutYear: "",
                  });
                }}
                className={`px-4 py-3 rounded-xl font-black cursor-pointer transition ${
                  activeDemoTab === "professional"
                    ? "bg-blue-700 text-white shadow-lg"
                    : "bg-transparent text-slate-700 hover:bg-white"
                }`}
              >
                Professional
              </button>
            </div>
          </div>

          {/* Student Fields */}
          {activeDemoTab === "student" && (
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label className="block mb-1 text-sm font-black tracking-wide text-slate-800">
                  College Name
                </label>

                <input
                  placeholder="College / University"
                  value={demoLeadForm.collegeName}
                  onChange={(event) =>
                    setDemoLeadForm({
                      ...demoLeadForm,
                      collegeName: event.target.value,
                    })
                  }
                  className={`w-full px-4 py-3 text-base font-semibold border rounded-xl shadow-sm outline-none transition focus:ring-4 focus:ring-blue-100 ${
                    demoFormErrors.collegeName
                      ? "border-red-500"
                      : "border-slate-200 focus:border-blue-500"
                  }`}
                />

                {demoFormErrors.collegeName && (
                  <p className="mt-1 text-sm font-semibold text-red-600">
                    {demoFormErrors.collegeName}
                  </p>
                )}
              </div>

              <div>
                <label className="block mb-1 text-sm font-black tracking-wide text-slate-800">
                  Passed Out Year / Pursuing Year
                </label>

                <input
                  placeholder="e.g. 2024"
                  maxLength={4}
                  inputMode="numeric"
                  value={demoLeadForm.passedOutYear}
                  onChange={(event) =>
                    setDemoLeadForm({
                      ...demoLeadForm,
                      passedOutYear: event.target.value.replace(/\D/g, ""),
                    })
                  }
                  className={`w-full px-4 py-3 text-base font-semibold border rounded-xl shadow-sm outline-none transition focus:ring-4 focus:ring-blue-100 ${
                    demoFormErrors.passedOutYear
                      ? "border-red-500"
                      : "border-slate-200 focus:border-blue-500"
                  }`}
                />

                {demoFormErrors.passedOutYear && (
                  <p className="mt-1 text-sm font-semibold text-red-600">
                    {demoFormErrors.passedOutYear}
                  </p>
                )}
              </div>
            </div>
          )}

          {/* Professional Fields */}
          {activeDemoTab === "professional" && (
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label className="block mb-1 text-sm font-black tracking-wide text-slate-800">
                  Company Name
                </label>

                <input
                  placeholder="Enter Company Name"
                  value={demoLeadForm.companyName}
                  onChange={(event) =>
                    setDemoLeadForm({
                      ...demoLeadForm,
                      companyName: event.target.value,
                    })
                  }
                  className={`w-full px-4 py-3 text-base font-semibold border rounded-xl shadow-sm outline-none transition focus:ring-4 focus:ring-blue-100 ${
                    demoFormErrors.companyName
                      ? "border-red-500"
                      : "border-slate-200 focus:border-blue-500"
                  }`}
                />

                {demoFormErrors.companyName && (
                  <p className="mt-1 text-sm font-semibold text-red-600">
                    {demoFormErrors.companyName}
                  </p>
                )}
              </div>

              <div>
                <label className="block mb-1 text-sm font-black tracking-wide text-slate-800">
                  No. Years Of Experience
                </label>

                <select
                  value={demoLeadForm.yearsOfExperience}
                  onChange={(event) =>
                    setDemoLeadForm({
                      ...demoLeadForm,
                      yearsOfExperience: event.target.value,
                    })
                  }
                  className={`w-full px-4 py-3 text-base font-semibold border rounded-xl shadow-sm outline-none transition focus:ring-4 focus:ring-blue-100 ${
                    demoFormErrors.yearsOfExperience
                      ? "border-red-500"
                      : "border-slate-200 focus:border-blue-500"
                  }`}
                >
                  <option value="">Select years</option>
                  {Array.from({ length: 11 }, (_, index) => (
                    <option key={index} value={index}>
                      {index}
                    </option>
                  ))}
                </select>

                {demoFormErrors.yearsOfExperience && (
                  <p className="mt-1 text-sm font-semibold text-red-600">
                    {demoFormErrors.yearsOfExperience}
                  </p>
                )}
              </div>
            </div>
          )}

          {/* Batch Day + Select Batch */}
          <div className="grid grid-cols-1 gap-5">
            <div>
              <label className="block mb-2 text-sm font-black tracking-wide text-slate-800">
                Batch Day
              </label>

              <select
                value={batchDayFilter}
                onChange={(event) => {
                  setBatchDayFilter(event.target.value);
                  setSelectedDemoBatchKey("");
                  setRequestCallback("NO");
                }}
                className="w-full px-4 py-3 text-base font-black border shadow-sm outline-none rounded-xl border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
              >
                <option value="MORNING">MORNING</option>
                <option value="EVENING">EVENING</option>
              </select>
            </div>

            <div>
              <label className="block mb-2 text-sm font-black tracking-wide text-slate-800">
                Select Batch
              </label>

              <div className="grid grid-cols-1 gap-3 min-h-[80px]">
                {loadingDemoBatches && (
                  <div className="flex justify-center py-6 text-sm font-bold text-slate-600">
                    Loading batches...
                  </div>
                )}

                {!loadingDemoBatches && demoBatchesError && (
                  <div className="p-4 text-sm font-bold text-red-700 border border-red-100 rounded-xl bg-red-50">
                    Failed to load batches: {demoBatchesError}
                  </div>
                )}

                {!loadingDemoBatches &&
                  !demoBatchesError &&
                  displayedDemoBatches.length === 0 && (
                    <div className="p-4 text-sm font-bold text-gray-600 border rounded-xl bg-slate-50 border-slate-200">
                      No demo batches available for the selected filter.
                    </div>
                  )}

                {!loadingDemoBatches &&
                  !demoBatchesError &&
                  displayedDemoBatches.map((batch) => {
                    const selected = selectedDemoBatchKey === batch.key;

                    return (
                      <button
                        key={batch.key}
                        type="button"
                        onClick={() => {
                          setSelectedDemoBatchKey(batch.key);
                          setRequestCallback("NO");
                        }}
                        className={`p-4 rounded-2xl border text-left transition cursor-pointer ${
                          selected
                            ? "border-blue-600 bg-blue-50 shadow-xl ring-2 ring-blue-200"
                            : "border-slate-200 hover:shadow-lg hover:-translate-y-0.5 bg-white"
                        }`}
                      >
                        <div className="flex items-center justify-between gap-3">
                          <div className="text-lg font-black text-slate-900">
                            {batch.label || "Batch"}
                          </div>

                          {selected && (
                            <span className="px-3 py-1 text-xs font-black text-blue-700 bg-blue-100 rounded-full">
                              Selected
                            </span>
                          )}
                        </div>

                        <div className="grid grid-cols-1 gap-2 mt-4 text-sm sm:grid-cols-3">
                          <div className="p-3 rounded-xl bg-slate-50">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Start Date
                            </p>
                            <p className="mt-1 font-black text-green-700">
                              {batch.batchStartIso
                                ? dayjs(batch.batchStartIso).format(
                                    "DD MMM YYYY"
                                  )
                                : "TBD"}
                            </p>
                          </div>

                          <div className="p-3 rounded-xl bg-slate-50">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Batch Day
                            </p>
                            <p
                              className={
                                batch.batchDay === "MORNING"
                                  ? "mt-1 text-amber-700 font-black"
                                  : batch.batchDay === "EVENING"
                                  ? "mt-1 text-red-700 font-black"
                                  : "mt-1 text-slate-600 font-black"
                              }
                            >
                              {batch.batchDay || "-"}
                            </p>
                          </div>

                          <div className="p-3 rounded-xl bg-slate-50">
                            <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                              Time
                            </p>
                            <p className="mt-1 font-black text-blue-800">
                              {batch.time || "TBD"}
                            </p>
                          </div>
                        </div>
                      </button>
                    );
                  })}
              </div>

              {demoFormErrors.batch && (
                <p className="mt-1 text-sm font-semibold text-red-600">
                  {demoFormErrors.batch}
                </p>
              )}
            </div>
          </div>

          {/* Callback */}
          {selectedDemoBatchKey && (
            <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
              <label className="text-sm font-black tracking-wide text-slate-800">
                Get a Call Back From Our Experts
              </label>

              <div className="flex gap-4 mt-3">
                <label className="flex items-center gap-2 px-4 py-2 bg-white border rounded-xl border-slate-200">
                  <input
                    type="radio"
                    name="requestCallback"
                    value="YES"
                    checked={requestCallback === "YES"}
                    onChange={(event) => setRequestCallback(event.target.value)}
                  />
                  <span className="font-black text-slate-800">YES</span>
                </label>

                <label className="flex items-center gap-2 px-4 py-2 bg-white border rounded-xl border-slate-200">
                  <input
                    type="radio"
                    name="requestCallback"
                    value="NO"
                    checked={requestCallback === "NO"}
                    onChange={(event) => setRequestCallback(event.target.value)}
                  />
                  <span className="font-black text-slate-800">NO</span>
                </label>
              </div>
            </div>
          )}

          {/* Buttons */}
          <div className="grid grid-cols-1 gap-4 pt-3 sm:grid-cols-2">
            <button
              type="submit"
              className="w-full py-4 text-lg font-black text-white transition cursor-pointer rounded-xl bg-gradient-to-r from-blue-700 to-cyan-500 shadow-lg shadow-blue-700/20 hover:scale-[1.02]"
            >
              Submit Registration
            </button>

            <button
              type="button"
              onClick={() => {
                setDemoLeadForm({
                  fullName: "",
                  email: "",
                  countryCode: "+91",
                  phone: "",
                  collegeName: "",
                  passedOutYear: "",
                  companyName: "",
                  yearsOfExperience: "",
                });
                setActiveDemoTab("professional");
                setBatchDayFilter("MORNING");
                setSelectedDemoBatchKey("");
                setRequestCallback("NO");
                setDemoFormErrors({});
                setDemoFormMessage("");
              }}
              className="w-full py-4 text-lg font-black text-white transition cursor-pointer rounded-xl bg-gradient-to-r from-slate-700 to-slate-950 shadow-lg hover:scale-[1.02]"
            >
              Reset Form
            </button>
          </div>

          {demoFormMessage && (
            <div
              className={`p-4 mt-4 text-center text-sm font-black rounded-xl ${
                demoFormMessage.toLowerCase().includes("failed") ||
                demoFormMessage.toLowerCase().includes("fix")
                  ? "text-red-700 bg-red-50 border border-red-100"
                  : "text-green-700 bg-green-50 border border-green-100"
              }`}
            >
              {demoFormMessage}
            </div>
          )}
        </form>
      </main>
    </div>
  </div>
</section>

 {/* COURSE CONTENT */}
<section className="relative px-4 py-10 overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50 md:px-20">
  {/* Background Effects */}
  <div className="absolute top-0 right-0 rounded-full w-96 h-96 bg-blue-200/40 blur-3xl"></div>
  <div className="absolute bottom-0 left-0 rounded-full w-96 h-96 bg-cyan-200/30 blur-3xl"></div>

  <div className="relative z-10 max-w-6xl mx-auto">
    {/* Heading */}
    <div className="max-w-4xl mx-auto mb-12 text-center">
      <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 border border-blue-200 rounded-full shadow-sm">
        <span className="w-2 h-2 bg-blue-700 rounded-full animate-pulse"></span>
        Structured Learning Path
      </span>

      <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
        Course <span className="text-blue-700">Content</span>
      </h2>

      <p className="max-w-6xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-600">
        Here’s a sneak peek into what we cover, week by week. The curriculum is
        designed to help you move from cybersecurity fundamentals to practical
        VAPT execution with real-world tools and attack scenarios.
      </p>
    </div>

    {/* Quick Summary Cards */}
    <div className="grid grid-cols-1 gap-4 mb-10 sm:grid-cols-3">
      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-3xl font-black text-blue-700">
          {courseModules.length}+
        </p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Core Modules
        </p>
      </div>

      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-3xl font-black text-purple-700">
          {courseModules.reduce(
            (total, module) => total + module.weeks.length,
            0
          )}
          +
        </p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Weekly Learning Blocks
        </p>
      </div>

      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-3xl font-black text-cyan-700">Hands-on</p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Practical VAPT Skills
        </p>
      </div>
    </div>

    {/* Course Modules Card */}
<div className="overflow-hidden bg-white border shadow-2xl rounded-3xl border-slate-200">
  {/* Header */}
  <div className="relative px-6 py-6 overflow-hidden bg-gradient-to-r from-slate-950 via-blue-950 to-slate-950">
    <div className="absolute inset-0 bg-blue-500/10"></div>

    <div className="relative flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="text-xs font-black tracking-widest uppercase text-cyan-300">
          Senior Penetration Tester Curriculum
        </p>

        <h3 className="mt-1 text-2xl font-black text-white">
          Course Modules
        </h3>
      </div>

      <span className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black text-green-300 border rounded-full bg-green-500/10 border-green-400/30">
        <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
        Updated Practical Syllabus
      </span>
    </div>
  </div>

  {/* Modules */}
  <div className="divide-y divide-slate-200">
    {courseModules.map((module, moduleIndex) => {
      const moduleOpen = openCourseModuleIndex === moduleIndex;

      return (
        <div key={module.title} className="bg-white">
          {/* Module Header */}
          <button
            type="button"
            onClick={() => handleCourseModuleToggle(moduleIndex)}
            className={`flex w-full items-center gap-4 px-5 py-6 text-left transition sm:px-7 focus:outline-none focus:ring-2 focus:ring-blue-300 ${
              moduleOpen
                ? "bg-blue-50"
                : "bg-slate-50 hover:bg-blue-50"
            }`}
          >
            {/* Module Number */}
            <span
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-sm font-black text-white shadow-lg transition ${
                moduleOpen
                  ? "bg-gradient-to-br from-blue-800 to-cyan-500 scale-105"
                  : "bg-gradient-to-br from-blue-700 to-cyan-500"
              }`}
            >
              {String(moduleIndex + 1).padStart(2, "0")}
            </span>

            {/* Title */}
            <div className="flex-1">
              <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                Module {moduleIndex + 1}
              </p>

              <h4 className="mt-1 text-lg font-black text-slate-950 md:text-xl">
                {module.title}
              </h4>
            </div>

            {/* Expand Icon */}
            <span
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 shadow-sm transition-transform duration-300 ${
                moduleOpen ? "rotate-45" : "rotate-0"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 4a1 1 0 011 1v4h4a1 1 0 110 2h-4v4a1 1 0 11-2 0v-4H5a1 1 0 110-2h4V5a1 1 0 011-1z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
          </button>

          {/* Smooth Module Content */}
          <div
            className={`grid transition-all duration-500 ease-in-out ${
              moduleOpen
                ? "grid-rows-[1fr] opacity-100"
                : "grid-rows-[0fr] opacity-0"
            }`}
          >
            <div className="overflow-hidden">
              <div className="px-5 py-5 bg-white sm:px-7">
                {module.weeks.map((weekItem, weekIndex) => {
                  const weekKey = `${moduleIndex}-${weekIndex}`;
                  const weekOpen = openCourseWeekKey === weekKey;

                  return (
                    <div
                      key={weekItem.week}
                      className="mb-4 overflow-hidden border shadow-sm rounded-2xl border-slate-200 last:mb-0"
                    >
                      {/* Week Header */}
                      <button
                        type="button"
                        onClick={() =>
                          handleCourseWeekToggle(moduleIndex, weekIndex)
                        }
                        className={`flex w-full items-center justify-between px-5 py-4 text-left text-white transition focus:outline-none ${
                          weekOpen
                            ? "bg-gradient-to-r from-blue-950 to-slate-950"
                            : "bg-gradient-to-r from-slate-950 to-blue-950 hover:from-blue-950 hover:to-slate-950"
                        }`}
                      >
                        <div className="flex items-center gap-3">
                          <span
                            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-slate-900 transition-transform duration-300 ${
                              weekOpen ? "rotate-45" : "rotate-0"
                            }`}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-4 h-4"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M10 4a1 1 0 011 1v4h4a1 1 0 110 2h-4v4a1 1 0 11-2 0v-4H5a1 1 0 110-2h4V5a1 1 0 011-1z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </span>

                          <span className="text-base font-black tracking-wide">
                            {weekItem.week}
                          </span>
                        </div>

                        <svg
                          className={`h-5 w-5 text-white transition-transform duration-300 ${
                            weekOpen ? "rotate-180" : "rotate-0"
                          }`}
                          viewBox="0 0 20 20"
                          fill="none"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.5"
                            d="M6 8l4 4 4-4"
                          />
                        </svg>
                      </button>

                      {/* Smooth Week Content */}
                      <div
                        className={`grid transition-all duration-500 ease-in-out ${
                          weekOpen
                            ? "grid-rows-[1fr] opacity-100"
                            : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <div className="p-5 bg-white">
                            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                              {weekItem.topics.map((topic) => (
                                <li
                                  key={topic}
                                  className="flex items-start gap-3 p-4 border rounded-2xl bg-slate-50 border-slate-200"
                                >
                                  <span className="flex items-center justify-center w-6 h-6 mt-0.5 text-xs font-black text-white bg-green-600 rounded-full shrink-0">
                                    ✓
                                  </span>

                                  <span className="text-sm font-bold leading-6 text-slate-800">
                                    {topic}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </div>
</div>

    {/* Download Brochure CTA */}
    <div className="mt-5 overflow-hidden bg-white border shadow-2xl rounded-3xl border-slate-200">
      <div className="grid items-center grid-cols-1 gap-6 p-6 md:grid-cols-[1fr_auto] md:p-8">
        <div>
          <p className="text-xl font-black text-slate-950">
            Want the complete detailed syllabus?
          </p>

          <p className="mt-2 text-base font-semibold leading-7 text-slate-600">
            Download the full curriculum PDF with complete module details,
            learning outcomes, tools covered, and practical training structure.
          </p>
        </div>

        <button
          type="button"
          onClick={handleDownloadBrochureClick}
          className="inline-flex items-center justify-center py-4 text-base font-black text-white transition-all duration-300 ease-in-out shadow-xl cursor-pointer px-7 rounded-2xl bg-gradient-to-r from-purple-600 via-blue-600 to-cyan-500 hover:shadow-2xl hover:scale-105"
        >
          📥 Download Brochure
        </button>
      </div>
    </div>
  </div>
</section>

   {/* TECHNOLOGIES */}
<section className="relative px-4 py-10 overflow-hidden bg-gradient-to-br from-white via-slate-50 to-blue-50 md:px-20">
  {/* Background Effects */}
  <div className="absolute top-0 left-0 rounded-full w-96 h-96 bg-blue-200/30 blur-3xl"></div>
  <div className="absolute bottom-0 right-0 rounded-full w-96 h-96 bg-cyan-200/30 blur-3xl"></div>

  <div className="relative z-10 max-w-6xl mx-auto">
    {/* Heading */}
    <div className="max-w-4xl mx-auto mb-12 text-center">
      <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 border border-blue-200 rounded-full shadow-sm">
        <span className="w-2 h-2 bg-blue-700 rounded-full animate-pulse"></span>
        Industry Standard Tools
      </span>

      <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
        Technologies You Will{" "}
        <span className="text-blue-700">Learn</span>
      </h2>

      <p className="mx-auto mt-5 text-lg font-semibold leading-8 max-w-7xl text-slate-600">
        Gain hands-on experience with real-world security tools and technologies
        used by professionals in day-to-day application security, VAPT, network
        security, and offensive security roles.
      </p>
    </div>

    {/* Enterprise Tool Container */}
    <div className="overflow-hidden bg-white border shadow-2xl rounded-3xl border-slate-200">
      {/* Header */}
      <div className="relative px-6 py-6 overflow-hidden bg-gradient-to-r from-slate-950 via-blue-950 to-slate-950">
        <div className="absolute inset-0 bg-blue-500/10"></div>

        <div className="relative flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-xs font-black tracking-widest uppercase text-cyan-300">
              Practical Tool-Based Learning
            </p>

            <h3 className="mt-1 text-2xl font-black text-white">
              Work With Real Security Tools
            </h3>
          </div>

          <span className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black text-green-300 border rounded-full bg-green-500/10 border-green-400/30">
            <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
            Hands-on Practice
          </span>
        </div>
      </div>

      {/* Description */}
      <div className="px-6 py-6 border-b bg-slate-50 border-slate-200">
        <p className="text-lg font-semibold leading-8 text-slate-700">
          You’ll get to work with industry-standard tools used in real security
          assessments, vulnerability scanning, traffic analysis, exploitation,
          reporting, and application security testing workflows.
        </p>
      </div>

      {/* Tools Grid */}
      <div className="grid grid-cols-2 gap-4 p-5 sm:grid-cols-3 md:grid-cols-5 md:p-8">
        {technologyLogos.map((tool, index) => (
          <div
            key={tool.alt}
            className="group relative flex min-h-[130px] items-center justify-center overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 shadow-lg transition duration-300 hover:-translate-y-1 hover:border-blue-300 hover:shadow-2xl"
          >
            {/* Hover Glow */}
            <div className="absolute inset-0 transition opacity-0 bg-gradient-to-br from-blue-50 via-white to-cyan-50 group-hover:opacity-100"></div>

            {/* Tool Number */}
            <span className="absolute top-3 left-3 flex h-7 w-7 items-center justify-center rounded-full bg-slate-100 text-[10px] font-black text-slate-500 transition group-hover:bg-blue-700 group-hover:text-white">
              {String(index + 1).padStart(2, "0")}
            </span>

            {/* Logo */}
            <img
              src={tool.image}
              alt={tool.alt}
              className={`${tool.className} relative z-10 object-contain transition duration-300 group-hover:scale-110`}
              loading="lazy"
            />

            {/* Tool Name */}
            <div className="absolute transition duration-300 translate-y-3 opacity-0 bottom-3 left-3 right-3 group-hover:translate-y-0 group-hover:opacity-100">
              <div className="px-3 py-2 text-center border border-blue-100 shadow-sm rounded-xl bg-white/90 backdrop-blur">
                <p className="text-xs font-black text-slate-800">
                  {tool.alt}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Bottom Highlights */}
    <div className="grid grid-cols-1 gap-4 mt-8 sm:grid-cols-3">
      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-2xl font-black text-blue-700">Scanning</p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Identify vulnerabilities using professional tools
        </p>
      </div>

      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-2xl font-black text-purple-700">Exploitation</p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Practice safe exploitation in lab environments
        </p>
      </div>

      <div className="p-5 text-center bg-white border shadow-lg rounded-2xl border-slate-200">
        <p className="text-2xl font-black text-cyan-700">Reporting</p>
        <p className="mt-1 text-sm font-bold text-slate-600">
          Learn assessment workflow and documentation
        </p>
      </div>
    </div>
  </div>
</section>

      {/* HIGHLIGHTS */}
      {/* <section className="px-4 py-12 bg-slate-50 md:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 text-center">
            <h2 className="text-3xl font-black text-slate-950">
              Course Highlights
            </h2>
            <p className="mt-3 text-lg font-semibold text-slate-700">
              Every course is packed with value-added features.
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {highlights.map((item) => (
              <div
                key={item}
                className="flex items-start gap-4 p-5 transition bg-white shadow-lg rounded-3xl hover:-translate-y-0.5 hover:shadow-xl"
              >
                <span className="text-2xl">🛡️</span>
                <h3 className="text-lg font-black text-slate-800">{item}</h3>
              </div>
            ))}
          </div>
        </div>
      </section> */}

 {/* COURSE FEE */}
<section className="relative px-4 py-8 overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50 md:px-20">
  {/* Background Effects */}
  <div className="absolute top-0 right-0 rounded-full w-96 h-96 bg-blue-200/40 blur-3xl"></div>
  <div className="absolute bottom-0 left-0 rounded-full w-96 h-96 bg-cyan-200/30 blur-3xl"></div>

  <div className="relative z-10 mx-auto max-w-7xl">
    {/* Header */}
    <div className="max-w-5xl mx-auto mb-12 text-center">
      <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 border border-blue-200 rounded-full shadow-sm">
        <span className="w-2 h-2 bg-blue-700 rounded-full animate-pulse"></span>
        Flexible Payment Options
      </span>

      <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
        Course <span className="text-blue-700">Fee</span>
      </h2>

      <p className="mx-auto mt-5 text-lg font-semibold leading-8 max-w-7xl text-slate-600">
        Learning shouldn’t be limited by finances. Secure your seat by paying in
        full, or choose a flexible installment option and start your practical
        cybersecurity journey with confidence.
      </p>
    </div>

    {/* Main Pricing Card */}
    <div className="relative max-w-6xl mx-auto">
      {/* Glow */}
      <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/20 via-cyan-400/20 to-purple-500/20 blur-2xl rounded-[2rem]"></div>

      <div className="relative overflow-hidden bg-white border shadow-2xl rounded-[2rem] border-slate-200">
        {/* Top Header */}
        <div className="relative px-6 py-6 overflow-hidden bg-gradient-to-r from-slate-950 via-blue-950 to-slate-950">
          <div className="absolute inset-0 bg-blue-500/10"></div>

          <div className="relative flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div>
              <p className="text-xs font-black tracking-widest uppercase text-cyan-300">
                Senior Penetration Tester Program
              </p>

              <h3 className="mt-1 text-2xl font-black text-white">
                Start Learning Today With Flexible Fee Options
              </h3>
            </div>

            <span className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black text-green-300 border rounded-full bg-green-500/10 border-green-400/30">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
              Limited Seats Available
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr]">
          {/* Left Price Panel */}
          <div className="relative p-6 overflow-hidden bg-gradient-to-br from-blue-700 via-blue-800 to-slate-950 md:p-8">
            <div className="absolute top-0 right-0 w-56 h-56 rounded-full bg-cyan-400/20 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-56 h-56 rounded-full bg-purple-400/20 blur-3xl"></div>

            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black text-white border rounded-full bg-white/10 border-white/20">
                <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                Best Value Program
              </div>

              <div className="mt-8 p-6 bg-white shadow-2xl rounded-[1.5rem]">
                <p className="text-sm font-black tracking-widest uppercase text-slate-500">
                  Total Course Fee
                </p>

                <p className="mt-3 text-5xl font-black tracking-tight text-slate-950">
                  {formatCurrency(fee.AfterOfferCourseFee || 19000)}
                </p>

                <div className="flex flex-wrap items-center gap-3 mt-4">
                  <span className="px-3 py-1 text-sm font-black text-green-700 bg-green-100 rounded-full">
                    {fee.DiscountPercentage || 24}% OFF
                  </span>

                  <span className="text-lg font-bold line-through text-slate-400">
                    {formatCurrency(fee.TotalCourseFee || 25000)}
                  </span>
                </div>

                <p className="mt-2 text-xs font-semibold text-slate-400">
                  (*Incl. Taxes)
                </p>

                <div className="p-4 mt-6 border rounded-2xl bg-slate-50 border-slate-200">
                  <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                    You Save
                  </p>

                  <p className="mt-1 text-2xl font-black text-green-700">
                    {formatCurrency(
                      (fee.TotalCourseFee || 25000) -
                        (fee.AfterOfferCourseFee || 19000)
                    )}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 mt-5">
                <div className="p-4 border rounded-2xl bg-white/10 border-white/15 backdrop-blur">
                  <p className="text-2xl font-black text-white">2 Years</p>
                  <p className="mt-1 text-xs font-bold text-blue-100">
                    Recording Access
                  </p>
                </div>

                <div className="p-4 border rounded-2xl bg-white/10 border-white/15 backdrop-blur">
                  <p className="text-2xl font-black text-white">1 Year</p>
                  <p className="mt-1 text-xs font-bold text-blue-100">
                    Cloud Labs
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="p-6 md:p-8">
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              {/* Installment Option */}
              <div className="p-5 border shadow-lg rounded-3xl bg-slate-50 border-slate-200">
                <p className="text-xs font-black tracking-widest text-blue-700 uppercase">
                  Installment Option
                </p>

                <p className="mt-3 text-3xl font-black text-slate-950">
                  {formatCurrency(fee.FirstInstallmentAmount || 12500)}
                </p>

                <p className="mt-1 text-sm font-bold text-slate-600">
                  First installment to reserve your seat
                </p>

                <div className="mt-5 space-y-3">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center justify-center w-6 h-6 text-xs font-black text-white bg-green-600 rounded-full">
                      ✓
                    </span>
                    <p className="text-sm font-bold text-slate-700">
                      Split your fee into two simple payments
                    </p>
                  </div>

                  <div className="flex items-center gap-3">
                    <span className="flex items-center justify-center w-6 h-6 text-xs font-black text-white bg-green-600 rounded-full">
                      ✓
                    </span>
                    <p className="text-sm font-bold text-slate-700">
                      No hidden cost in payment structure
                    </p>
                  </div>

                  <div className="flex items-center gap-3">
                    <span className="flex items-center justify-center w-6 h-6 text-xs font-black text-white bg-green-600 rounded-full">
                      ✓
                    </span>
                    <p className="text-sm font-bold text-slate-700">
                      Start learning with lower upfront payment
                    </p>
                  </div>
                </div>
              </div>

              {/* Full Payment Option */}
              <div className="p-5 border border-blue-200 shadow-lg rounded-3xl bg-gradient-to-br from-blue-50 to-white">
                <p className="text-xs font-black tracking-widest text-blue-700 uppercase">
                  Full Payment Option
                </p>

                <p className="mt-3 text-3xl font-black text-slate-950">
                  {formatCurrency(fee.AfterOfferCourseFee || 19000)}
                </p>

                <p className="mt-1 text-sm font-bold text-slate-600">
                  One-time payment for complete program access
                </p>

                <div className="mt-5 space-y-3">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center justify-center w-6 h-6 text-xs font-black text-white bg-blue-700 rounded-full">
                      ✓
                    </span>
                    <p className="text-sm font-bold text-slate-700">
                      Immediate enrollment confirmation
                    </p>
                  </div>

                  <div className="flex items-center gap-3">
                    <span className="flex items-center justify-center w-6 h-6 text-xs font-black text-white bg-blue-700 rounded-full">
                      ✓
                    </span>
                    <p className="text-sm font-bold text-slate-700">
                      Access to live classes, recordings, labs and support
                    </p>
                  </div>

                  <div className="flex items-center gap-3">
                    <span className="flex items-center justify-center w-6 h-6 text-xs font-black text-white bg-blue-700 rounded-full">
                      ✓
                    </span>
                    <p className="text-sm font-bold text-slate-700">
                      Best option to secure your seat instantly
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Cohort Alert */}
            <div className="p-5 mt-6 bg-white border shadow-lg rounded-3xl border-slate-200">
              <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="text-xs font-black tracking-widest uppercase text-slate-400">
                    Next Cohort Starts
                  </p>

                  <p className="mt-1 text-2xl font-black text-slate-950">
                    {getDisplayDate(latestCohort.BatchStartDate)}
                  </p>
                </div>

                <div className="relative inline-flex items-center gap-2 px-4 py-2 overflow-hidden text-xs font-black text-black border rounded-md shadow-lg bg-gradient-to-r from-pink-500 via-yellow-400 to-green-500 border-white/40 animate-confetti-blink">
                  <span className="absolute w-1.5 h-1.5 bg-red-500 rounded-full top-1 left-3 animate-confetti-dot"></span>
                  <span className="absolute w-1.5 h-1.5 bg-blue-500 rounded-full top-2 right-4 animate-confetti-dot-delay"></span>
                  <span className="absolute w-1.5 h-1.5 bg-yellow-300 rounded-full bottom-1 left-8 animate-confetti-dot"></span>
                  <span className="absolute w-1.5 h-1.5 bg-purple-500 rounded-full bottom-2 right-8 animate-confetti-dot-delay"></span>


                  <span className="relative z-10 drop-shadow-sm">
                    {latestCohort.SeatsAvailable || "Limited Seats Available"}
                  </span>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="grid grid-cols-1 gap-4 mt-6 sm:grid-cols-2">
              <button
                type="button"
                onClick={() => {
                  trackEvent("full_payment_click", {
                    amount: fee.AfterOfferCourseFee,
                  });

                  window.open(
                    "https://rzp.io/rzp/senior-full",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
                className="relative inline-flex items-center justify-center px-6 py-4 overflow-hidden text-lg font-black text-white transition shadow-xl cursor-pointer rounded-2xl bg-gradient-to-r from-blue-700 to-cyan-500 shadow-blue-700/20 hover:scale-[1.03] hover:shadow-2xl"
              >
                <span className="absolute inset-0 transition opacity-0 bg-white/20 hover:opacity-100"></span>
                <span className="relative z-10">Enroll Now →</span>
              </button>

              <button
                type="button"
                onClick={() => setInstallmentOpen(true)}
                className="relative inline-flex items-center justify-center px-6 py-4 overflow-hidden text-lg font-black text-white transition shadow-xl cursor-pointer rounded-2xl bg-gradient-to-r from-green-600 to-emerald-500 shadow-green-700/20 hover:scale-[1.03] hover:shadow-2xl"
              >
                <span className="absolute inset-0 transition opacity-0 bg-white/20 hover:opacity-100"></span>
                <span className="relative z-10">
                  <i className="mr-2 fas fa-wallet"></i>
                  Pay In Installments
                </span>
              </button>
            </div>

            {/* Assurance Strip */}
            <div className="grid grid-cols-1 gap-3 mt-6 sm:grid-cols-3">
              <div className="p-4 text-center border rounded-2xl bg-slate-50 border-slate-200">
                <p className="text-sm font-black text-slate-950">
                  Secure Payment
                </p>
              </div>

              <div className="p-4 text-center border rounded-2xl bg-slate-50 border-slate-200">
                <p className="text-sm font-black text-slate-950">
                  Live Classes
                </p>
              </div>

              <div className="p-4 text-center border rounded-2xl bg-slate-50 border-slate-200">
                <p className="text-sm font-black text-slate-950">
                  Job-Focused
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Note */}
      <p className="max-w-6xl mx-auto mt-8 text-sm font-semibold leading-7 text-center text-slate-600">
        Program fee includes live instructor-led sessions, access to recordings,
        practical labs, mentorship support, mock interview preparation, and
        career-focused guidance.
      </p>
    </div>
  </div>
</section>

{/* EXPERT-LED INSTRUCTORS */}
<section className="px-4 py-10 bg-white md:px-20">
  <div className="mx-auto max-w-7xl">
    {/* Heading */}
    <div className="max-w-5xl mx-auto mb-10 text-center">
      <span className="inline-flex items-center px-4 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 rounded-full">
        Industry Mentorship
      </span>

      <h2 className="mt-4 text-3xl font-extrabold text-gray-900 md:text-4xl">
        Expert-Led Instructors
      </h2>

      <p className="mx-auto mt-4 text-lg font-medium leading-relaxed text-gray-700 max-w-7xl">
        Learn from industry veterans who have secured global systems. Our
        instructors combine hands-on security experience, real-time case
        studies, and practical guidance to help you become job-ready.
      </p>

      <p className="mt-4 text-lg font-extrabold text-gray-900">
        “Our mentors are not just trainers — they are practitioners.”
      </p>
    </div>

    {/* Instructor Card */}
    <div className="relative max-w-6xl mx-auto overflow-hidden bg-white border shadow-2xl rounded-3xl border-slate-200">
      {/* Top Gradient Border */}
      <div className="h-2 bg-gradient-to-r from-blue-700 via-purple-600 to-cyan-500"></div>

      <div className="grid gap-8 p-6 md:p-8 lg:grid-cols-[260px_1fr]">
        {/* Left Profile Block */}
        <div className="flex flex-col items-center justify-center p-6 border bg-gradient-to-br from-slate-950 to-blue-950 rounded-3xl border-slate-800">
          {/* <div className="flex items-center justify-center text-4xl font-black text-white rounded-full shadow-xl w-28 h-28 bg-gradient-to-br from-blue-500 to-cyan-400">
            GB
          </div> */}

          <h3 className="mt-5 text-2xl font-extrabold text-center text-white">
            G. Bhavani
          </h3>

          <p className="mt-2 text-sm font-semibold text-center text-blue-100">
            Security Consultant
          </p>

          <p className="mt-1 text-xs font-bold tracking-widest text-center uppercase text-cyan-300">
            Big 4 Consulting Experience
          </p>
        </div>

        {/* Right Content */}
        <div className="flex flex-col justify-center">
          <div className="flex flex-wrap gap-3 mb-5">
            {[
              "Application Security",
              "VAPT",
              "Web Security",
              "API Security",
              "Network Security",
              "Mobile Security",
            ].map((skill) => (
              <span
                key={skill}
                className="px-4 py-2 text-xs font-extrabold text-blue-800 border border-blue-100 rounded-full bg-blue-50"
              >
                {skill}
              </span>
            ))}
          </div>

          <h3 className="text-2xl font-extrabold text-gray-900">
            Practical Cybersecurity Training from Real Industry Experience
          </h3>

          <p className="mt-4 text-base font-semibold leading-8 text-gray-700">
            With 5 years of experience in Application Security and Vulnerability
            Assessment & Penetration Testing (VAPT), Bhavani brings a
            well-rounded skill set and strong industry expertise to the
            classroom. She is currently working as a Security Consultant for one
            of the Big 4 consulting firms, where she plays a key role in
            securing digital assets across critical domains.
          </p>

          <div className="grid gap-4 mt-7 sm:grid-cols-3">
            <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
              <p className="text-3xl font-black text-blue-700">5+</p>
              <p className="mt-1 text-sm font-bold text-gray-700">
                Years Experience
              </p>
            </div>

            <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
              <p className="text-3xl font-black text-purple-700">VAPT</p>
              <p className="mt-1 text-sm font-bold text-gray-700">
                Core Expertise
              </p>
            </div>

            <div className="p-4 border rounded-2xl bg-slate-50 border-slate-200">
              <p className="text-3xl font-black text-cyan-700">Live</p>
              <p className="mt-1 text-sm font-bold text-gray-700">
                Practical Mentoring
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom Note */}
    <div className="max-w-5xl mx-auto mt-8 text-center">
      <p className="text-base font-semibold text-gray-700">
        Every session is designed to connect concepts with real-world security
        testing scenarios, industry workflows, and interview-focused practical
        knowledge.
      </p>
    </div>
  </div>
</section>

{/* CALLBACK MODAL */}
{callbackOpen && (
  <div
    className="fixed inset-0 z-[100] flex items-start justify-center p-2 overflow-y-auto bg-slate-950/80 backdrop-blur-md sm:items-center sm:p-4"
    onClick={(event) => {
      if (event.target === event.currentTarget) {
        setCallbackOpen(false);
      }
    }}
  >
    <form
      onSubmit={handleCallbackSubmit}
      className="relative w-full max-w-2xl my-4 overflow-hidden bg-white border shadow-2xl rounded-2xl border-white/20 text-slate-950 max-h-[92vh] overflow-y-auto"
    >
      {/* Background Glow */}
      <div className="absolute top-0 right-0 w-48 h-48 rounded-full bg-blue-200/40 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-cyan-200/30 blur-3xl"></div>

      {/* Close Button */}
      <button
        type="button"
        onClick={() => setCallbackOpen(false)}
        className="absolute z-30 flex items-center justify-center text-xl font-black transition bg-white border rounded-full shadow-lg cursor-pointer w-9 h-9 right-3 top-3 text-slate-600 border-slate-200 hover:text-red-600 hover:scale-110"
        aria-label="Close callback form"
      >
        &times;
      </button>

      {/* Header */}
      <div className="relative z-10 px-4 py-4 overflow-hidden pr-14 bg-gradient-to-r from-slate-950 via-blue-950 to-slate-950 sm:px-5 sm:py-5">
        <div className="absolute inset-0 bg-blue-500/10"></div>

        <div className="relative">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 text-[10px] font-black tracking-widest text-cyan-300 uppercase border rounded-full bg-white/10 border-white/15">
            <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
            Course Counselling Request
          </span>

          <h2 className="mt-3 text-2xl font-black tracking-tight text-white sm:text-3xl">
            Get a Callback
          </h2>

          <p className="mt-2 text-xs font-semibold leading-5 text-blue-100 sm:text-sm">
            Share your details. Our course counsellor will contact you shortly
            and guide you with batch details, fee options, and enrollment steps.
          </p>
        </div>
      </div>

      {/* Body */}
      <div className="relative z-10 p-4 sm:p-5">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {/* Full Name */}
          <div>
            <label className="block mb-1.5 text-xs font-black tracking-wide text-slate-800 sm:text-sm">
              Full Name
            </label>

            <input
              type="text"
              placeholder="Enter your full name"
              value={callbackForm.name}
              onChange={(event) =>
                setCallbackForm({
                  ...callbackForm,
                  name: event.target.value,
                })
              }
              className="w-full px-3 py-2.5 text-sm font-semibold transition bg-white border shadow-sm outline-none rounded-xl border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block mb-1.5 text-xs font-black tracking-wide text-slate-800 sm:text-sm">
              Email
            </label>

            <input
              type="email"
              placeholder="you@example.com"
              value={callbackForm.email}
              onChange={(event) =>
                setCallbackForm({
                  ...callbackForm,
                  email: event.target.value,
                })
              }
              className="w-full px-3 py-2.5 text-sm font-semibold transition bg-white border shadow-sm outline-none rounded-xl border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
            />
          </div>
        </div>

        {/* Phone Number */}
        <div className="mt-4">
          <label className="block mb-1.5 text-xs font-black tracking-wide text-slate-800 sm:text-sm">
            Phone Number
          </label>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-[150px_1fr]">
            <select
              value={callbackForm.countryCode}
              onChange={(event) =>
                setCallbackForm({
                  ...callbackForm,
                  countryCode: event.target.value,
                })
              }
              className="w-full px-3 py-2.5 text-xs font-bold transition bg-white border shadow-sm outline-none rounded-xl border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 sm:text-sm"
            >
              {COUNTRY_CODES.map((country) => (
                <option
                  key={`callback-${country.name}-${country.code}`}
                  value={country.code}
                >
                  {country.name} ({country.code})
                </option>
              ))}
            </select>

            <input
              type="tel"
              placeholder="Mobile number"
              value={callbackForm.phone}
              onChange={(event) =>
                setCallbackForm({
                  ...callbackForm,
                  phone: event.target.value,
                })
              }
              className="w-full px-3 py-2.5 text-sm font-semibold transition bg-white border shadow-sm outline-none rounded-xl border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
            />
          </div>
        </div>

        {/* Message */}
        <div className="mt-4">
          <label className="block mb-1.5 text-xs font-black tracking-wide text-slate-800 sm:text-sm">
            Message
          </label>

          <textarea
            placeholder="Describe your requirement"
            rows={3}
            maxLength={500}
            value={callbackForm.message}
            onChange={(event) =>
              setCallbackForm({
                ...callbackForm,
                message: event.target.value,
              })
            }
            className="w-full px-3 py-2.5 text-sm font-semibold transition bg-white border shadow-sm outline-none resize-none rounded-xl border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
          />

          <div className="flex items-center justify-between gap-3 mt-1.5">
            <p className="text-[11px] font-bold text-slate-500">
              Our counsellor will use this to understand your requirement.
            </p>

            <p className="text-[11px] font-black text-slate-500 whitespace-nowrap">
              {callbackForm.message.length}/500
            </p>
          </div>
        </div>

        {/* Trust Strip */}
        <div className="grid grid-cols-3 gap-2 mt-4">
          <div className="p-2 text-center border rounded-xl bg-slate-50 border-slate-200">
            <p className="text-xs font-black text-blue-700">Batch</p>
          </div>

          <div className="p-2 text-center border rounded-xl bg-slate-50 border-slate-200">
            <p className="text-xs font-black text-purple-700">Fee</p>
          </div>

          <div className="p-2 text-center border rounded-xl bg-slate-50 border-slate-200">
            <p className="text-xs font-black text-cyan-700">Career</p>
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="relative inline-flex items-center justify-center w-full px-5 py-3 mt-5 overflow-hidden text-base font-black text-white transition shadow-xl cursor-pointer rounded-xl bg-gradient-to-r from-blue-700 via-cyan-600 to-blue-700 shadow-blue-700/20 hover:scale-[1.02] hover:shadow-2xl"
        >
          <span className="absolute inset-0 transition opacity-0 bg-white/20 hover:opacity-100"></span>
          <span className="relative z-10">Submit Callback Request →</span>
        </button>
      </div>
    </form>
  </div>
)}

{/* INSTALLMENT MODAL */}
{installmentOpen && (
  <div
    className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
    onClick={(event) => {
      if (event.target === event.currentTarget) {
        setInstallmentOpen(false);
      }
    }}
  >
    <div className="w-full max-w-2xl overflow-hidden bg-white shadow-2xl rounded-3xl text-slate-950">
      <div className="relative px-6 py-5 bg-slate-950">
        <button
          type="button"
          onClick={() => setInstallmentOpen(false)}
          className="absolute text-3xl font-black text-white cursor-pointer right-5 top-3 hover:text-red-400"
          aria-label="Close installment modal"
        >
          &times;
        </button>

        <h2 className="text-2xl font-black text-center text-white">
          Pay In Installments
        </h2>

        <p className="mt-2 text-sm font-semibold text-center text-slate-300">
          Select your preferred batch and continue with the first installment.
        </p>
      </div>

      <div className="p-6 space-y-6">
        <div className="p-5 border rounded-2xl bg-slate-50 border-slate-200">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h3 className="text-xl font-black text-slate-950">
                Senior Penetration Tester
              </h3>
              <p className="mt-1 text-sm font-bold text-slate-600">
                LIVE + 2 years access to recordings
              </p>
            </div>

            <div className="text-left sm:text-right">
              <p className="text-sm font-bold text-slate-500">
                Final Course Fee
              </p>
              <p className="text-2xl font-black text-blue-700">
                {formatCurrency(fee.AfterOfferCourseFee)}
              </p>
            </div>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <div className="p-5 border border-blue-100 rounded-2xl bg-blue-50">
            <p className="text-sm font-black text-blue-800">
              1st Installment
            </p>
            <p className="mt-2 text-3xl font-black text-slate-950">
              {formatCurrency(fee.FirstInstallmentAmount)}
            </p>
          </div>

          <div className="p-5 border rounded-2xl border-slate-200 bg-slate-50">
            <p className="text-sm font-black text-slate-700">
              2nd Installment
            </p>
            <p className="mt-2 text-3xl font-black text-slate-950">
              {formatCurrency(fee.SecondInstallmentAmount)}
            </p>
          </div>
        </div>

        <div>
          <p className="mb-3 text-base font-black text-slate-900">
            Select Your Batch
          </p>

          <div className="grid gap-3 sm:grid-cols-2">
            {cohorts.map((cohort) => {
              const batchLabel = `${cohort.BatchType || "Batch"} - Starts ${
                cohort.BatchStartDate || ""
              } - ${cohort.Timings || ""}`;

              const selected = selectedInstallmentBatch === batchLabel;

              return (
                <button
                  key={cohort.id || batchLabel}
                  type="button"
                  onClick={() => setSelectedInstallmentBatch(batchLabel)}
                  className={`p-4 text-left transition border rounded-2xl ${
                    selected
                      ? "border-blue-600 bg-blue-50 ring-2 ring-blue-200"
                      : "border-slate-200 bg-white hover:bg-slate-50"
                  }`}
                >
                  <p className="text-base font-black text-slate-950">
                    {cohort.BatchType || "Batch"}
                  </p>

                  <p className="mt-1 text-sm font-bold text-green-700">
                    Starts: {getDisplayDate(cohort.BatchStartDate)}
                  </p>

                  <p className="mt-1 text-sm font-semibold text-slate-600">
                    Time: {cohort.Timings || "TBD"}
                  </p>
                </button>
              );
            })}
          </div>
        </div>

        {selectedInstallmentBatch && (
          <div className="p-4 border border-green-100 rounded-2xl bg-green-50">
            <p className="text-sm font-black text-green-800">
              Selected Batch
            </p>
            <p className="mt-1 text-sm font-bold text-slate-800">
              {selectedInstallmentBatch}
            </p>
          </div>
        )}

        <div className="flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={handleInstallmentPayment}
            className="flex-1 py-4 text-lg font-black text-white transition bg-blue-700 shadow-lg rounded-xl hover:bg-blue-800"
          >
            Pay First Installment
          </button>

          <button
            type="button"
            onClick={() => setInstallmentOpen(false)}
            className="flex-1 py-4 text-lg font-black transition border rounded-xl border-slate-300 text-slate-700 hover:bg-slate-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{/* DOWNLOAD BROCHURE MODAL */}
{brochureOpen && (
  <div
    className="fixed inset-0 z-[110] flex items-start justify-center p-2 overflow-y-auto bg-slate-950/80 backdrop-blur-md sm:items-center sm:p-4"
    onClick={(event) => {
      if (event.target === event.currentTarget) {
        setBrochureOpen(false);
      }
    }}
  >
    <div className="relative w-full max-w-xl my-4 overflow-hidden bg-white border shadow-2xl rounded-2xl border-white/20 text-slate-950 max-h-[92vh] overflow-y-auto">
      {/* Background Glow */}
      <div className="absolute top-0 right-0 w-48 h-48 rounded-full bg-blue-200/40 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-cyan-200/30 blur-3xl"></div>

      {/* Close Button */}
      <button
        type="button"
        onClick={() => setBrochureOpen(false)}
        className="absolute z-30 flex items-center justify-center text-xl font-black transition bg-white border rounded-full shadow-lg cursor-pointer w-9 h-9 right-3 top-3 text-slate-600 border-slate-200 hover:text-red-600 hover:scale-110"
        aria-label="Close brochure form"
      >
        &times;
      </button>

      {/* Header */}
      <div className="relative z-10 px-4 py-4 overflow-hidden pr-14 bg-gradient-to-r from-slate-950 via-blue-950 to-slate-950 sm:px-5 sm:py-5">
        <div className="absolute inset-0 bg-blue-500/10"></div>

        <div className="relative">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 text-[10px] font-black tracking-widest text-cyan-300 uppercase border rounded-full bg-white/10 border-white/15">
            <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
            Complete Curriculum PDF
          </span>

          <h3 className="mt-3 text-2xl font-black tracking-tight text-white sm:text-3xl">
            Download Brochure
          </h3>

          <p className="mt-2 text-xs font-semibold leading-5 text-blue-100 sm:text-sm">
            Get the detailed syllabus, tools covered, learning roadmap, and
            course structure instantly.
          </p>
        </div>
      </div>

      {/* Body */}
      <form onSubmit={handleBrochureSubmit} className="relative z-10 p-4 space-y-4 sm:p-5">
        {/* Name Field */}
        <div>
          <label className="block mb-1.5 text-xs font-black tracking-wide text-slate-800 sm:text-sm">
            Full Name
          </label>

          <div className="relative">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              value={brochureForm.name}
              onChange={(event) =>
                setBrochureForm({
                  ...brochureForm,
                  name: event.target.value,
                })
              }
              className={`w-full px-3 py-2.5 pr-10 text-sm font-semibold transition bg-white border shadow-sm outline-none rounded-xl focus:ring-4 focus:ring-blue-100 ${
                brochureErrors.name
                  ? "border-red-500"
                  : brochureForm.name.trim().length >= 3
                  ? "border-green-500"
                  : "border-slate-200 focus:border-blue-500"
              }`}
            />

            {brochureForm.name.trim().length >= 3 && !brochureErrors.name && (
              <span className="absolute flex items-center justify-center w-6 h-6 text-white transform -translate-y-1/2 bg-green-500 rounded-full right-3 top-1/2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.707-4.707a1 1 0 111.414-1.414L8.414 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
            )}
          </div>

          {brochureErrors.name && (
            <p className="mt-1 text-xs font-semibold text-red-600">
              {brochureErrors.name}
            </p>
          )}
        </div>

        {/* Email Field */}
        <div>
          <label className="block mb-1.5 text-xs font-black tracking-wide text-slate-800 sm:text-sm">
            Email Address
          </label>

          <div className="relative">
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              required
              value={brochureForm.email}
              onChange={(event) =>
                setBrochureForm({
                  ...brochureForm,
                  email: event.target.value,
                })
              }
              className={`w-full px-3 py-2.5 pr-10 text-sm font-semibold transition bg-white border shadow-sm outline-none rounded-xl focus:ring-4 focus:ring-blue-100 ${
                brochureErrors.email
                  ? "border-red-500"
                  : validateEmailValue(brochureForm.email)
                  ? "border-green-500"
                  : "border-slate-200 focus:border-blue-500"
              }`}
            />

            {validateEmailValue(brochureForm.email) &&
              !brochureErrors.email && (
                <span className="absolute flex items-center justify-center w-6 h-6 text-white transform -translate-y-1/2 bg-green-500 rounded-full right-3 top-1/2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 text-white"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.707-4.707a1 1 0 111.414-1.414L8.414 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              )}
          </div>

          {brochureErrors.email && (
            <p className="mt-1 text-xs font-semibold text-red-600">
              {brochureErrors.email}
            </p>
          )}
        </div>

        {/* Phone Field */}
        <div>
          <label className="block mb-1.5 text-xs font-black tracking-wide text-slate-800 sm:text-sm">
            Phone Number
          </label>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-[150px_1fr]">
            <select
              name="countryCode"
              value={brochureForm.countryCode}
              onChange={(event) =>
                setBrochureForm({
                  ...brochureForm,
                  countryCode: event.target.value,
                })
              }
              className="w-full px-3 py-2.5 text-xs font-bold transition bg-white border shadow-sm outline-none rounded-xl border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 sm:text-sm"
            >
              {COUNTRY_CODES.map((country) => (
                <option
                  key={`brochure-${country.name}-${country.code}`}
                  value={country.code}
                >
                  {country.name} ({country.code})
                </option>
              ))}
            </select>

            <input
              type="tel"
              name="phone"
              placeholder="Contact Number"
              required
              value={brochureForm.phone}
              onChange={(event) =>
                setBrochureForm({
                  ...brochureForm,
                  phone: event.target.value,
                })
              }
              className={`w-full px-3 py-2.5 text-sm font-semibold transition bg-white border shadow-sm outline-none rounded-xl focus:ring-4 focus:ring-blue-100 ${
                brochureErrors.phone
                  ? "border-red-500"
                  : brochureForm.phone &&
                    !validatePhoneValue(brochureForm.phone)
                  ? "border-green-500"
                  : "border-slate-200 focus:border-blue-500"
              }`}
            />
          </div>

          {brochureErrors.phone && (
            <p className="mt-1 text-xs font-semibold text-red-600">
              {brochureErrors.phone}
            </p>
          )}
        </div>

        {/* Trust Strip */}
        <div className="grid grid-cols-3 gap-2">
          <div className="p-2 text-center border rounded-xl bg-slate-50 border-slate-200">
            <p className="text-xs font-black text-blue-700">Syllabus</p>
          </div>

          <div className="p-2 text-center border rounded-xl bg-slate-50 border-slate-200">
            <p className="text-xs font-black text-purple-700">Tools</p>
          </div>

          <div className="p-2 text-center border rounded-xl bg-slate-50 border-slate-200">
            <p className="text-xs font-black text-cyan-700">Roadmap</p>
          </div>
        </div>

        {/* Buttons */}
        <div className="grid grid-cols-1 gap-3 pt-2 sm:grid-cols-[1fr_auto] sm:items-center">
          <button
            type="submit"
            className="relative inline-flex items-center justify-center w-full px-5 py-3 overflow-hidden text-base font-black text-white transition shadow-xl cursor-pointer rounded-xl bg-gradient-to-r from-blue-700 via-cyan-600 to-blue-700 shadow-blue-700/20 hover:scale-[1.02] hover:shadow-2xl"
          >
            <span className="absolute inset-0 transition opacity-0 bg-white/20 hover:opacity-100"></span>
            <span className="relative z-10">📩 Download Now</span>
          </button>

          <button
            type="button"
            onClick={() => setBrochureOpen(false)}
            className="px-5 py-3 text-sm font-black transition border cursor-pointer rounded-xl text-slate-700 border-slate-200 hover:text-red-600 hover:bg-red-50"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
)}

      {/* WHATSAPP STICKY BUTTON */}
<button
  type="button"
  onClick={toggleWhatsAppModal}
  className="fixed z-50 p-3 px-4 text-white transition -translate-y-1/2 rounded-full shadow-lg cursor-pointer top-1/2 right-6 bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:opacity-90 animate-pulse"
  aria-label="Join WhatsApp"
>
  <i className="text-4xl fa-brands fa-whatsapp"></i>
</button>

{/* WHATSAPP MODAL */}
{whatsappOpen && (
  <div
    className="fixed z-50 p-4 transition-opacity duration-300 -translate-y-1/2 bg-white shadow-xl top-1/2 right-20 rounded-xl w-72"
    role="dialog"
    aria-modal="true"
    aria-labelledby="whatsappTitle"
    onClick={(event) => event.stopPropagation()}
  >
    {/* Close Button */}
    <button
      type="button"
      onClick={toggleWhatsAppModal}
      className="absolute text-3xl text-gray-600 cursor-pointer top-2 left-4 hover:text-red-500"
      aria-label="Close"
    >
      &times;
    </button>

    <h2
      id="whatsappTitle"
      className="mt-6 mb-2 text-lg font-bold text-center text-gray-800"
    >
      Unsure about which course to choose?
    </h2>

    <p className="mb-3 text-sm text-center text-gray-700">
      Tap below to start a WhatsApp chat — we're here to help!
    </p>

    <div className="flex flex-col items-center gap-3">
      <button
        type="button"
        onClick={openWhatsAppChat}
        className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-white transition bg-green-600 rounded-full hover:bg-green-700"
        aria-label="Chat Now on WhatsApp"
      >
        <i className="fa-brands fa-whatsapp"></i>
        Chat Now
      </button>

      <button
        type="button"
        onClick={openWhatsAppAppFallback}
        className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-gray-800 transition border border-gray-200 rounded-full hover:bg-gray-50"
        aria-label="Open in WhatsApp App"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4 text-green-600"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M20.52 3.48A11.93 11.93 0 0012 .5C5.73.5.99 5.24.99 11.5c0 2.01.53 3.95 1.53 5.68L0 24l6.97-1.79c1.61.45 3.28.68 4.9.68 6.27 0 11.01-4.74 11.01-11 0-3.02-1.18-5.85-3.36-7.41zM12 21.5c-1.44 0-2.86-.34-4.14-.99l-.3-.15-4.14 1.06 1.15-3.98-.18-.31A8.12 8.12 0 013 11.5c0-4.97 4.06-9 9-9 2.41 0 4.66.94 6.36 2.64a8.95 8.95 0 012.64 6.36c0 4.97-4.06 9-9 9z" />
        </svg>
        Open in App
      </button>
    </div>
  </div>
)}

{/* FLOATING CALL BUTTON */}
<a
  href="tel:+91-9080432374"
  className="fixed z-50 p-3 text-white transition rounded-md shadow-lg cursor-pointer bg-violet-600 bottom-60 right-7 hover:bg-green-700"
  aria-label="Call Us"
>
  <i className="text-2xl fa-solid fa-phone"></i>
</a>

{/* BACK TO TOP BUTTON */}
{showBackToTop && (
  <button
    type="button"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    className="fixed z-50 p-4 text-white transition bg-blue-700 rounded-lg shadow-lg cursor-pointer bottom-12 right-7 hover:bg-blue-800"
    aria-label="Back to top"
  >
    <i className="text-xl fa-solid fa-arrow-up"></i>
  </button>
)}

    </main>
  );
}

function InfoItem({ label, value, valueClassName = "text-black", iconType }) {
  return (
    <div className="flex items-center gap-2 px-6 py-5">
      <div className="p-3 rounded-full bg-blue-50">
        {iconType === "calendar" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M8 7V3m8 4V3M3 11h18M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        ) : iconType === "learning" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 20l9-5-9-5-9 5 9 5z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 12V4"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        )}
      </div>

      <div>
        <p className="text-sm text-gray-700">{label}</p>
        <p className={`font-bold ${valueClassName}`}>{value}</p>
      </div>
    </div>
  );
}

export default SeniorPenetrationTester;